
  (function () {
  /* Escapes text for an alt attribute. A function declaration, so it exists before any view renders. */
  function ppAlt(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); }
    /* ===== PDP data (extracted from the design prototype) ===== */
    var PP_IMG = window.__PP_IMG || {};
    var PP_PRODUCTS = [
      { slug:'prostate', name:'10-in-1 Prostate Complex', short:'Prostate', ck:'prostate', hook:'Supports normal urinary flow*', line:'ProstaFlow™', active:'Saw Palmetto 320mg', price:34, rating:0, count:0, tint:'#2c3a46', badge:'Best seller', servings:'60 caps · 30-day supply', longHook:'Ten actives working together for prostate and urinary health, led by Saw Palmetto at a clinically-studied 320mg and Beta-Sitosterol 200mg. Supports normal urinary flow and helps maintain a healthy prostate size.*', benefits:['Supports normal urinary flow*','Helps maintain healthy prostate size*','10 actives, no proprietary blend'], facts:[['Saw Palmetto (45% fatty acids)','320 mg'],['Beta-Sitosterol','200 mg'],['Pygeum Bark','100 mg'],['Zinc (as citrate)','15 mg · 136% DV']], pairs:['immune-365','resvera'] },
      { slug:'sleep-clean', name:'Sleep Clean', short:'Sleep', ck:'sleep', hook:'Deep sleep, no grogginess*', line:'RestPure™', active:'Ashwagandha + L-Theanine', price:29, rating:0, count:0, tint:'#3b3969', badge:'', servings:'60 caps · 30-day supply', longHook:'A melatonin-free sleep aid built around Ashwagandha and L-Theanine to help you unwind and wake up clear — not foggy.*', benefits:['Unwind and drift off naturally*','Wake up clear and rested*','Melatonin-free, non-habit forming'], facts:[['Ashwagandha (KSM-66)','600 mg'],['L-Theanine','200 mg'],['Magnesium Glycinate','150 mg']], pairs:['vervain','resvera'] },
      { slug:'vervain', name:'Blue Vervain Complex', short:'Vervain', ck:'sleep', hook:'Calm mind, steady gut*', line:'CalmAxis™', active:'Blue Vervain 200mg', price:27, rating:0, count:0, tint:'#22564a', badge:'', servings:'60 caps · 30-day supply', longHook:'Blue Vervain with L-Theanine and chamomile to ease everyday tension and support focus — without drowsiness.*', benefits:['Eases everyday tension & stress*','Supports focus and clarity*','Non-drowsy'], facts:[['Blue Vervain (2% verbascoside)','200 mg'],['L-Theanine','150 mg'],['Chamomile Extract','100 mg']], pairs:['sleep-clean','spirulina'] },
      { slug:'gut-sweep', name:'Gut Sweep', short:'Gut Sweep', ck:'gut', hook:'Everyday gut cleanse*', line:'PuraGut™', active:'Berberine + Oregano', price:32, rating:0, count:0, tint:'#48481f', badge:'', servings:'90 caps · 30-day supply', longHook:'A 9-in-1 daily cleanse with Berberine and Oregano to support intestinal cleansing and a balanced microbiome.*', benefits:['Supports intestinal cleansing*','Promotes a balanced gut microbiome*','9-in-1 daily cleanse'], facts:[['Berberine HCl','500 mg'],['Oregano Extract','400 mg'],['Black Walnut Hull','200 mg']], pairs:['gut-defense','spirulina'] },
      { slug:'gut-defense', name:'Gut Defense Complex', short:'Gut Defense', ck:'gut', hook:'Soothe & rebalance your gut*', line:'H. Pylori Support*', active:'Mastic Gum 500mg', price:32, rating:0, count:0, tint:'#1f5849', badge:'New', servings:'60 caps · 30-day supply', longHook:'Mastic Gum with bismuth and berberine to soothe the gut lining and support a healthy microbiome.*', benefits:['Supports a healthy gut microbiome*','Promotes digestive comfort*','60 billion CFU'], facts:[['Mastic Gum','500 mg'],['Bismuth','120 mg'],['Berberine HCl','200 mg']], pairs:['gut-sweep','immune-365'] },
      { slug:'immune-365', name:'Immune 365', short:'Immune', ck:'immune', hook:'Stay ready, all 365 days*', line:'Defend365™', active:'Vitamin C · D3 · Zinc', price:28, rating:0, count:0, tint:'#a3522b', badge:'Best seller', servings:'60 caps · 30-day supply', longHook:'A 10-in-1 immune formula with Vitamin C, D3, Zinc and Wellmune beta-glucans to support a healthy immune response year-round.*', benefits:['Supports a healthy immune response*','Quercetin & olive leaf antioxidants*','10-in-1 formula'], facts:[['Vitamin C','250 mg · 278% DV'],['Vitamin D3','2000 IU · 250% DV'],['Zinc','15 mg · 136% DV'],['Wellmune Beta-Glucans','250 mg']], pairs:['monolaurin','resvera'] },
      { slug:'monolaurin', name:'Monolaurin', short:'Mono', ck:'immune', hook:'Immune & gut defense*', line:'LauriGuard™', active:'Monolaurin 1,000mg', price:30, rating:0, count:0, tint:'#2c4b53', badge:'', servings:'60 caps · 30-day supply', longHook:'Monolaurin from coconut with olive leaf and zinc — a full-strength daily defense stack.*', benefits:['Supports immune resilience*','A 5-ingredient daily stack','Full-strength dose'], facts:[['Monolaurin (GML)','1,000 mg'],['Olive Leaf Extract','200 mg'],['Zinc','10 mg · 91% DV']], pairs:['immune-365','gut-defense'] },
      { slug:'resvera', name:'Resvera Plus', short:'Resvera', ck:'longevity', hook:'Age on your own terms*', line:'CellAge™', active:'Trans-Resveratrol 250mg', price:39, rating:0, count:0, tint:'#442a3a', badge:'', servings:'60 caps · 30-day supply', longHook:'Trans-Resveratrol at 250mg with pterostilbene and grape seed OPCs for cellular health and healthy-aging antioxidant support.*', benefits:['Supports cellular health & longevity*','Antioxidant support for healthy aging*','98% purity'], facts:[['Trans-Resveratrol (98%)','250 mg'],['Pterostilbene','50 mg'],['Grape Seed OPCs','100 mg']], pairs:['spirulina','immune-365'] },
      { slug:'spirulina', name:'Blue + Green Spirulina', short:'Spirulina', ck:'longevity', hook:'4g of blue-green power, daily', line:'PhycoBlue™', active:'Hawaiian + Blue Spirulina', price:36, rating:0, count:0, tint:'#7d4d5b', badge:'', form:'powder', servings:'30 servings · just add water', longHook:'Hawaiian and blue spirulina delivering 4g of daily greens with phycocyanin for antioxidant and clean-energy support.*', benefits:['Antioxidant & immune support*','Clean plant protein + iron','Just add water'], facts:[['Hawaiian Spirulina','3,000 mg'],['Blue Spirulina (Phycocyanin)','1,000 mg']], pairs:['resvera','gut-sweep'] },
      { slug:'hair', name:'Hair Growth & Root Defense', short:'Hair', ck:'hair', hook:'Feed the follicle*', line:'RootRevive™', active:'Biotin 5,000mcg', price:33, rating:0, count:0, tint:'#4e3a28', badge:'', servings:'60 caps · 30-day supply', longHook:'Biotin at 5,000mcg with Saw Palmetto and keratin support to nourish follicles at the root for thicker, fuller-looking hair.*', benefits:['Supports thicker, fuller-looking hair*','Nourishes follicles at the root*','+ Keratin support'], facts:[['Biotin','5,000 mcg'],['Saw Palmetto','320 mg'],['Keratin','100 mg']], pairs:['resvera','spirulina'] }
    ];
    /* Real Shopify data (price, image, variant, availability) is emitted by the
       section into window.__PP_REAL, keyed by slug. It overrides the demo values
       above so the builder, the formula cards and the stack maths quote live
       prices and show real product photos instead of the grey placeholders.
       Marketing copy (name, line, hook) is left as authored. */
    var PP_REAL = window.__PP_REAL || {};
    PP_PRODUCTS.forEach(function (p) {
      var r = PP_REAL[p.slug];
      if (!r) { p.available = false; return; }
      if (typeof r.priceCents === 'number') { p.price = r.priceCents / 100; }
      /* Real subscription price straight from the selling-plan allocation, so the
         card quotes the exact figure Shopify will charge instead of a made-up 15%. */
      if (typeof r.subPriceCents === 'number') { p.subPrice = r.subPriceCents / 100; }
      if (r.variantId) { p.variantId = r.variantId; }
      p.url = r.url; p.requiresPlan = !!r.requiresPlan;
      if (r.name) p.name = r.name;
      if (r.sellingPlanId) { p.sellingPlanId = r.sellingPlanId; }
      if (typeof r.available === 'boolean') { p.available = r.available; }
      if (r.img) { PP_IMG[p.slug] = r.img; }
      /* Real rating/count from the product's own Amazon reviews imported by
         Appio (snippets/product-rating-data). 0 reviews -> count 0, and every view gates
         its rating/reviews block on count > 0 so no fabricated stars are shown. */
      if (typeof r.reviewCount === 'number') { p.count = r.reviewCount; }
      p.rating = (typeof r.rating === 'number') ? r.rating : 0;
    });
    PP_PRODUCTS = PP_PRODUCTS.filter(function (p) { return !!p.variantId; });
    var PP_SPECIAL = {
      'sleep-clean':'Take 30–60 minutes before bed. Because it promotes relaxation, don’t drive or operate heavy machinery right after taking it.',
      'gut-sweep':'Take with food. If you take prescription medication, talk to your physician first — berberine can affect how some drugs are metabolized.',
      'gut-defense':'Best on an empty stomach, ~30 minutes before meals. Intended for use up to 8 weeks, then reassess with your provider.',
      'monolaurin':'Start with 1 capsule daily and increase gradually to assess tolerance.',
      'resvera':'Take with a meal containing some fat to support absorption.',
      'spirulina':'Start with half a scoop to assess tolerance. Reseal tightly and keep dry.',
      'hair':'Biotin can interfere with certain lab tests (including some thyroid and cardiac panels) — tell your provider you take it before bloodwork.'
    };
    var PP_DEF_SPECIAL = 'Keep out of reach of children. Store in a cool, dry place away from direct light, and reseal tightly after each use. Do not use if the safety seal is broken.';
    /* Ingredient library data. Prefers the library_ingredient metaobjects
       (window.__PP_ING, editable in Admin > Content > Metaobjects); falls back to
       this built-in list if none are set. */
    var PP_ING = (window.__PP_ING && window.__PP_ING.length) ? window.__PP_ING : [
      { name:'Saw Palmetto', cat:'Prostate', dose:'320 mg · 45% fatty acids', benefit:'Supports normal urinary flow and helps maintain a healthy prostate size.*', studies:12, found:['prostate','hair'] },
      { name:'Beta-Sitosterol', cat:'Prostate', dose:'200 mg', benefit:'Plant sterol that supports prostate and healthy cholesterol already in range.*', studies:8, found:['prostate'] },
      { name:'Ashwagandha', cat:'Sleep & Stress', dose:'600 mg · KSM-66', benefit:'Adaptogen shown to support stress resilience and restful sleep.*', studies:15, found:['sleep-clean'] },
      { name:'L-Theanine', cat:'Calm & Focus', dose:'150–200 mg', benefit:'Amino acid from tea that promotes calm, focused attention without drowsiness.*', studies:9, found:['sleep-clean','vervain'] },
      { name:'Blue Vervain', cat:'Mood', dose:'200 mg · 2% verbascoside', benefit:'Traditional botanical that eases everyday tension and stress.*', studies:4, found:['vervain'] },
      { name:'Berberine', cat:'Gut & Metabolic', dose:'500 mg', benefit:'Supports a balanced gut microbiome and healthy metabolic function.*', studies:20, found:['gut-sweep'] },
      { name:'Mastic Gum', cat:'Gut', dose:'500 mg', benefit:'Resin traditionally used to soothe the gut lining and digestive comfort.*', studies:7, found:['gut-defense'] },
      { name:'Vitamin C', cat:'Immune', dose:'250 mg · 278% DV', benefit:'Antioxidant vitamin that supports a healthy immune response.*', studies:30, found:['immune-365'] },
      { name:'Vitamin D3', cat:'Immune', dose:'2000 IU · 250% DV', benefit:'Supports immune function and bone health, especially in low-sun months.*', studies:40, found:['immune-365'] },
      { name:'Zinc', cat:'Immune', dose:'10–15 mg', benefit:'Essential mineral central to immune cell function.*', studies:25, found:['immune-365','monolaurin'] },
      { name:'Monolaurin', cat:'Immune', dose:'1,000 mg · GML', benefit:'Coconut-derived lipid used for daily immune defense.*', studies:5, found:['monolaurin'] },
      { name:'Trans-Resveratrol', cat:'Longevity', dose:'250 mg · 98%', benefit:'Polyphenol that supports cellular health and healthy aging.*', studies:14, found:['resvera'] },
      { name:'Spirulina', cat:'Greens & Energy', dose:'4,000 mg', benefit:'Blue-green algae rich in antioxidants, plant protein, and iron.*', studies:10, found:['spirulina'] },
      { name:'Biotin', cat:'Hair & Skin', dose:'5,000 mcg', benefit:'B-vitamin that supports the keratin structure of hair, skin, and nails.*', studies:11, found:['hair'] }
    ];
    /* Builder discount tiers. The homepage banner states a percentage in copy
       and the builder used to hard-code its own, so the two could disagree the
       moment anyone edited one. Both read this. */
    var PP_BUNDLE_TIERS = (function () {
      var t = window.__PP_BUNDLE_TIERS || {};
      var two = parseFloat(t.two);
      var three = parseFloat(t.three);
      return { two: isNaN(two) ? 0 : two, three: isNaN(three) ? 0 : three };
    })();
    /* The five curated stacks from the design prototype. Member lines and
       per-product prices are read from PP_PRODUCTS so a catalog edit cannot
       leave a stack describing something it no longer contains, and every
       price shown for a stack is derived by ppStackTotals rather than taken
       from the `was`/`now`/`save` fields below — those were hand-set and
       disagree with both the members and the 15% the bands advertise. They are
       kept only as the source of the starter kit's own copy.

       Foundation is kitOnly, as in the prototype: it is the Starter Kit's
       stack, so it is excluded from the stack panel and the bundles grid to
       avoid selling the same three bottles twice on one page. */
    var PP_STACKS = [
      { key:'foundation', kitOnly:true, name:'Foundation', eyebrow:'The everyday base', tagline:'The daily baseline.',
        who:'The daily baseline — defense, real sleep, and cellular support in one routine.',
        was:96, now:78, save:'Save $18', slugs:['immune-365','sleep-clean','resvera'],
        am:'Immune 365 · 2 capsules with breakfast',
        pm:'Sleep Clean · 2 capsules 45 min before bed + Resvera Plus · 1 capsule',
        notFor:['You only want one bottle — start with Immune 365','You are pregnant or nursing without clinician sign-off','You already take a melatonin sleep aid nightly'],
        ph:'Three-bottle Foundation Stack on a calm morning counter' },
      { key:'gut-reset', name:'Gut Reset', eyebrow:'The 30-day reset', tagline:'Thirty days, one reset.',
        who:'For the month your digestion needs a hard reset. After antibiotics, travel, or years of feeling “fine.”',
        was:100, now:79, save:'Save $21', slugs:['gut-sweep','gut-defense','spirulina'],
        am:'Gut Sweep · 2 capsules before breakfast',
        pm:'Gut Defense · 2 capsules + Spirulina · 1 scoop',
        notFor:['You want a gentle daily routine — this is a 30-day reset','You are pregnant or nursing without clinician sign-off','You are mid-course on a prescribed antibiotic'],
        ph:'Gut Reset trio with fresh greens, overhead flat lay' },
      { key:'flow', name:'Flow', eyebrow:'The flow-first stack', tagline:'Flow first, defense behind it.',
        who:'For the man who’s up twice a night. Prostate and flow support first, daily defense right behind it.',
        was:101, now:82, save:'Save $19', slugs:['prostate','immune-365','resvera'],
        am:'Prostate Complex · 2 capsules with breakfast',
        pm:'Immune 365 · 2 capsules + Resvera Plus · 1 capsule',
        notFor:['You have not discussed urinary changes with a clinician yet','You are pregnant or nursing without clinician sign-off','You want cellular support only — see Longevity'],
        ph:'Flow Stack bottles on a bedside table, early light' },
      { key:'defense', name:'Daily Defense', eyebrow:'The two-bottle shield', tagline:'Two bottles, packed and ready.',
        who:'For travel weeks and season changes. Broad immune support without a shelf full of bottles.',
        was:71, now:59, save:'Save $12', slugs:['immune-365','monolaurin'],
        am:'Immune 365 · 2 capsules with breakfast',
        pm:'Monolaurin · 2 capsules with your evening meal',
        notFor:['You want sleep or gut support in the same stack','You are pregnant or nursing without clinician sign-off','You are looking for a single daily multivitamin'],
        ph:'Two-bottle defense pair packed in a travel dopp kit' },
      { key:'longevity', name:'Longevity', eyebrow:'The cellular stack', tagline:'Play the long game.',
        who:'For the long game. Polyphenols and whole-food nutrition for cellular defense that ages well.',
        was:75, now:63, save:'Save $12', slugs:['resvera','spirulina'],
        am:'Spirulina · 1 scoop in water or a smoothie',
        pm:'Resvera Plus · 1 capsule with your evening meal',
        notFor:['You want immune or sleep support — see Foundation','You are pregnant or nursing without clinician sign-off','You take blood thinners — ask about resveratrol first'],
        ph:'Longevity pair beside a bowl of berries, soft daylight' }
    ];
    /* Curated-stacks panel source. When the section has pp_stack metaobjects
       connected (up to four), it emits them into window.__PP_STACKS already
       priced and with their products, images and links resolved — that drives
       the panel. With none connected the built-in stacks above are the fallback,
       and they keep the in-app detail view (#pp-stack/<key>) working. The two
       shapes differ: a metaobject entry carries `lines`/`nowCents`, a built-in
       carries `slugs`; renderStacks branches on that. */
    var PP_STACKS_PANEL = (function () {
      var live = window.__PP_STACKS;
      if (Object.prototype.toString.call(live) === '[object Array]' && live.length) { return live; }
      return null;
    })();
    /* Shown on the stack detail view, as in the prototype. */
    var PP_STACK_REVIEWS = [];
    /* The stacks the storefront actually offers. PP_BUNDLES used to be a
       separate array here, re-listing three of these with a second set of
       hardcoded prices, so the bundles grid and the stack panel could quote
       different figures for the same stack. One list now, as the prototype
       does it (_stacksVisible). */
    var PP_STACKS_VISIBLE = PP_STACKS.filter(function (s) { return !s.kitOnly; });
    var PP_KIT_STACK = PP_STACKS.filter(function (s) { return s.kitOnly; })[0] || PP_STACKS[0];
    /* Lot registry — the ONLY lots the COA lookup will verify.
       [lot number, product display name, tested date, product slug]
       Replace with real lab lot records (and per-lot PDF links) before launch;
       lookups for lots not listed here return a "not found" state. */
    var PP_LOTS = [];
    var PP_LOT_BY_SLUG = {};
    PP_LOTS.forEach(function (l) { PP_LOT_BY_SLUG[l[3]] = l; });
    function ppFindLot(q) {
      var needle = String(q || '').trim().toUpperCase();
      if (!needle) { return null; }
      for (var i = 0; i < PP_LOTS.length; i++) {
        if (PP_LOTS[i][0].toUpperCase() === needle) { return PP_LOTS[i]; }
      }
      return null;
    }
    /* Built-in six: the fallback, and the source of per-field defaults when a
       pp_concern entry leaves subline or tint empty. */
    var PP_CONCERNS_BUILTIN = [
      { key:'prostate', name:'Prostate & Flow', sub:'Urinary flow · prostate size*', tint:'#2c3a46' },
      { key:'sleep', name:'Sleep & Calm', sub:'Fall asleep · stay calm*', tint:'#3b3969' },
      { key:'gut', name:'Gut & Digestion', sub:'Regularity · gut lining*', tint:'#1f5849' },
      { key:'immune', name:'Immunity & Defense', sub:'Daily immune support*', tint:'#a3522b' },
      { key:'longevity', name:'Longevity & Cellular', sub:'Antioxidant · cellular*', tint:'#442a3a' },
      { key:'hair', name:'Hair, Skin & Roots', sub:'Follicle & root support*', tint:'#4e3a28' }
    ];
    /* pp_concern metaobjects (emitted as window.__PP_CONCERNS by the section)
       drive the client-side views — quiz step 1, the shop tabs, the protocol
       summary — so they match the server-rendered menus, tiles and finder
       banner. Falls back to the built-ins when no entries exist. */
    var PP_CONCERNS = (function () {
      var live = window.__PP_CONCERNS;
      if (Object.prototype.toString.call(live) !== '[object Array]') { return PP_CONCERNS_BUILTIN; }
      /* Tints are concatenated into style="--ct:…" attributes, so only let
         through values that are actually colors. */
      var SAFE_COLOR = /^(#[0-9a-f]{3,8}|rgba?\([\d\s.,%]+\)|[a-z]+)$/i;
      var seen = {};
      var out = [];
      live.forEach(function (c) {
        if (!c) { return; }
        var key = String(c.key || '').trim();
        if (!key || seen[key]) { return; }
        seen[key] = true;
        var fb = null;
        PP_CONCERNS_BUILTIN.forEach(function (d) { if (d.key === key) { fb = d; } });
        var tint = String(c.tint || '').trim();
        out.push({
          key: key,
          name: String(c.name || '').trim() || (fb && fb.name) || key,
          sub: String(c.sub || '').trim() || (fb ? fb.sub : ''),
          tint: SAFE_COLOR.test(tint) ? tint : ((fb && fb.tint) || '#2c3a46')
        });
      });
      return out.length ? out : PP_CONCERNS_BUILTIN;
    })();
    var PP_CONCERN_BY_KEY = {};
    PP_CONCERNS.forEach(function (c) { PP_CONCERN_BY_KEY[c.key] = c; });
    var PP_BY_SLUG = {};
    var PP_BY_NAME = {};
    PP_PRODUCTS.forEach(function (p) { PP_BY_SLUG[p.slug] = p; PP_BY_NAME[p.name] = p.slug; });
    function ppOverlaps(slugs) {
      var out = [];
      PP_ING.forEach(function (i) {
        var shared = i.found.filter(function (s) { return slugs.indexOf(s) > -1; });
        if (shared.length > 1 && ['Prostate','Calm & Focus','Immune','Sleep & Stress'].indexOf(i.cat) > -1) {
          out.push(i.name + ' appears in ' + shared.map(function (s) { return PP_BY_SLUG[s].name; }).join(' and ') + ' — you may not need both.');
        }
      });
      return out;
    }

    function ppHexRgb(h) { h = h.replace('#',''); return [0,2,4].map(function (i) { return parseInt(h.slice(i, i+2), 16); }); }
    function ppSoft(h, a) { var c = ppHexRgb(h); return 'rgba(' + c[0] + ',' + c[1] + ',' + c[2] + ',' + a + ')'; }
    function ppShade(h, p) { var c = ppHexRgb(h).map(function (x) { return Math.round(p < 0 ? x * (1 + p) : x + (255 - x) * p); }); return 'rgb(' + c[0] + ',' + c[1] + ',' + c[2] + ')'; }

    /* Derived fields — same logic as the prototype */
    function ppDerive(p) {
      var isPowder = /water/i.test(p.servings);
      var m = p.servings.match(/(\d+)\s*caps/i);
      var capCount = m ? parseInt(m[1], 10) : 60;
      var perServing = capCount >= 90 ? 3 : 2;
      return {
        isPowder: isPowder,
        subPrice: ((typeof p.subPrice === 'number') ? p.subPrice : (p.price * 0.85)).toFixed(2),
        servingSize: isPowder ? '1 level scoop (approx. 5 g)' : perServing + ' vegetable capsules',
        servingsPer: isPowder ? '30' : String(Math.round(capCount / perServing)),
        capsuleForm: isPowder ? 'Single scoop included' : (capCount >= 90 ? 'Size 0 vegetable capsule' : 'Size 00 vegetable capsule'),
        capsuleWidthMm: capCount >= 90 ? 21.7 : 23.3,
        capsuleLabel: isPowder ? 'One rounded scoop' : (capCount >= 90 ? 'Size 0 · easy-swallow' : 'Size 00 · standard'),
        capsuleLenLabel: isPowder ? '—' : ((capCount >= 90 ? 21.7 : 23.3) + ' mm long'),
        otherIng: isPowder ? 'Natural flavor, citric acid, organic stevia leaf extract.' : 'Vegetable cellulose (capsule shell), organic rice concentrate, organic rice hull.',
        howTo: isPowder ? 'Mix one scoop into 8–12 oz of cold water, juice, or a smoothie once daily. Best taken in the morning.' : 'Take 2 capsules once daily with a meal. Consistency matters more than timing — same time each day works best.',
        special: PP_SPECIAL[p.slug] || PP_DEF_SPECIAL,
        fullFacts: p.facts.map(function (f) { return { n: f[0], a: f[1], dv: f[1].indexOf('%') > -1 ? '' : '†' }; }),
        ingredientRows: p.facts.map(function (f) {
          var hit = null;
          PP_ING.forEach(function (i) {
            if (!hit && (i.name.toLowerCase() === f[0].toLowerCase() || f[0].toLowerCase().indexOf(i.name.toLowerCase()) > -1)) { hit = i; }
          });
          return { n: f[0], a: f[1], why: hit ? hit.benefit : 'Included at a transparent, label-stated amount — no proprietary blend.', studyLabel: hit ? hit.studies + ' studies' : 'Fully disclosed' };
        }),
        how: p.benefits.map(function (b, i) { return { no: '0' + (i + 1), b: b }; }),
        timeline: [
          { no:'01', wk:'Days 1–7', t:'Settling in', b:'You start a simple daily habit. Nothing dramatic yet — this is about consistency and letting levels build.' },
          { no:'02', wk:'Weeks 2–4', t:'First signals', b:'Most people begin to notice subtle day-to-day shifts. Keep the habit steady — consistency is what builds the effect.*' },
          { no:'03', wk:'Weeks 6–8', t:'Full effect', b:'The formula reaches its stride. This is the window we ask you to judge results — and where subscribers see the most value.*' }
        ],
        whoFor: p.benefits.slice(0, 3),
        whoNot: ['You want an overnight fix — this works gradually, with daily use', 'You’re pregnant or nursing without clinician sign-off', 'You already take an overlapping active (our finder will flag it)'],
        faqs: [
          { q:'When will I notice a difference?', a:'Most people take ' + p.name + ' consistently for 4–8 weeks before judging results — the effects build with daily use.*' },
          { q:'Is every batch third-party tested?', a:'Yes. Each lot is tested by an independent lab for potency, heavy metals, and microbials. Search your lot number on the Transparency page to read the full certificate.' },
          { q:'Can I take it alongside my other supplements?', a:'Generally, yes. Our protocol finder flags overlapping actives so you don’t double up. As always, check with your clinician if you take medication.' }
        ],
        vsRows: [
          { label:'Every dose printed on the label', us:'Yes', them:'“Blend”' },
          { label:'Clinically-studied amounts', us:'Yes', them:'Rarely' },
          { label:'Third-party COA per lot', us:'Public', them:'None' },
          { label:'Fillers & flow agents', us:'None', them:'Common' }
        ]
      };
    }

    var roots = document.querySelectorAll('.pp-home');
    Array.prototype.forEach.call(roots, function (root) {
      /* The ZenMen homepage embeds PP's band designs inside a .pp-home wrapper
         purely to reuse this file's CSS. That copy is driven by ZenMen's own
         data and its own inline script, so pp-home.js must not wire it with the
         Precise catalog — skip any root flagged data-zen-embed. */
      if (root.hasAttribute('data-zen-embed')) { return; }
      /* --- Product detail view (PDP) --- */
      var pdpSection = root.querySelector('[data-pp-pdp]');
      var pdpMount = root.querySelector('[data-pp-pdp-render]');
      /* The toast itself, not a button that triggers one. */
      var toastEl = root.querySelector('[data-pp-toast-el]');
      var toastLiveEl = root.querySelector('[data-pp-toast-live]');
      var shopSection = root.querySelector('[data-pp-shop]');
      var shopMount = root.querySelector('[data-pp-shop-render]');
      if (!(pdpSection && pdpMount && shopSection && shopMount) && !root.hasAttribute('data-pp-chrome-only')) {
        /* The entire router/quiz/email app depends on these mounts — fail loudly.
           data-pp-chrome-only roots (the header alone, rendered on every non-homepage
           page) never have them by design, so they don't warn. */
        try { console.warn('[pp-home] missing mount element(s); PP router, quiz and email modal are disabled on this page.'); } catch (err) {}
      }
      if (pdpSection && pdpMount && shopSection && shopMount) {
        var pdpState = { slug: null, sub: true, qty: 1, ing: 0 };
        var shopState = { open: false, concern: 'All' };
        /* Per-card buy state, as in the prototype: each formula remembers its
           own supply tier and whether it is being bought on a plan or once. */
        var PP_TIERS = [
          { q: 1, label: 'Monthly', disc: 0 },
          { q: 3, label: '3-mo supply', disc: 0.10 },
          { q: 6, label: '6-mo supply', disc: 0.18 }
        ];
        var buyState = { mode: {}, tier: {} };
        var ppMoney = function (n) { return window.zpMoney(Math.round(Number(n) * 100)); };
        /* Every stack price on the site comes from here: sum the members, apply
           the shared 3+ bundle tier. The stacks carry their own `now`/`was`/
           `save` from the prototype, but those were hand-set and disagree both
           with the member prices and with the "any 3+ formulas get bundle
           pricing" copy the bands run under — Gut Reset was $100 -> $79, a 21%
           cut, on a page advertising 15%. Quoting them left the homepage panel,
           the stack page, the builder and the other-stacks row all showing
           different numbers for the same stack. */
        var ppStackTotals = function (slugs) {
          var pct = parseFloat((window.__PP_BUNDLE_TIERS || {}).three);
          if (isNaN(pct)) { pct = 0; }
          var was = 0, now = 0;
          (slugs || []).forEach(function (slug) {
            for (var i = 0; i < PP_PRODUCTS.length; i++) {
              if (PP_PRODUCTS[i].slug === slug) {
                var price = Number(PP_PRODUCTS[i].price);
                was += price;
                /* Rounded per member, then summed — the prototype's own maths
                   (_charged) and what the Starter Kit already does. Discounting
                   the total instead can land a cent off the sum of the lines a
                   shopper is reading right above it. */
                now += Number((price * (1 - (pct / 100))).toFixed(2));
                return;
              }
            }
          });
          return { was: was, now: now, save: was - now };
        };
        /* Everything the card shows about price is derived here so the tier
           and plan pills can never disagree with the figure beside them. */
        var buyFigures = function (p) {
          var q = buyState.tier[p.slug] || 1;
          var tier = null;
          for (var i = 0; i < PP_TIERS.length; i++) { if (PP_TIERS[i].q === q) { tier = PP_TIERS[i]; } }
          if (!tier) { tier = PP_TIERS[0]; }
          var once = Number(p.price) * tier.q * (1 - tier.disc);
          /* Prefer the real per-delivery subscribe price from Shopify; fall back to
             the demo 15% only when the product has no live plan price. */
          var subUnit = (typeof p.subPrice === 'number') ? p.subPrice : Number(p.price) * 0.85;
          var sub = subUnit * tier.q * (1 - tier.disc);
          /* Only offer Subscribe & save on products that actually have a Shopify
             selling plan. Without one, "subscribe" would advertise a discount and a
             plan that don't exist, then quietly add a one-time order at full price.
             Those products are one-time only. */
          var hasSub = !!p.sellingPlanId;
          /* Real % off, rounded, so the label never over-promises the discount. */
          var savePct = Number(p.price) > 0 ? Math.round((1 - subUnit / Number(p.price)) * 100) : 0;
          var onceSel = p.requiresPlan ? false : (hasSub ? (buyState.mode[p.slug] === 'once') : true);
          var shown = onceSel ? once : sub;
          return {
            tier: tier,
            hasSub: hasSub,
            savePct: savePct,
            onceSel: onceSel,
            priceOnce: ppMoney(once),
            priceSub: ppMoney(sub),
            perDay: ppMoney(shown / (30 * tier.q)) + '/day',
            shipNote: 'Shipping calculated at checkout',
            subNote: onceSel ? 'No commitment · 90-day money-back guarantee' : '90-day money-back guarantee'
          };
        };
        var savedScroll = 0;
        var toastTimer = null;
        var STARS = '★★★★★';
        var closeEmail = null;
        var ppEmailShown = null;

        /* History writes can throw in sandboxed contexts (theme editor preview iframe).
           URL sync is best-effort there, so failures are swallowed on purpose. */
        var histPush = function (state, url) { try { history.pushState(state, '', url); } catch (err) {} };
        var histReplace = function (state, url) { try { history.replaceState(state, '', url); } catch (err) {} };

        var toast = function () {
          if (!toastEl) { return; }
          toastEl.classList.add('is-on');
          /* The visible toast text never changes, so a screen reader would stay silent.
             Re-inserting the message into the hidden live region forces an announcement. */
          if (toastLiveEl) {
            toastLiveEl.textContent = '';
            setTimeout(function () { toastLiveEl.textContent = toastEl.textContent; }, 60);
          }
          if (toastTimer) { clearTimeout(toastTimer); }
          toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2200);
        };

        var pdpHTML = function (p) {
          var d = ppDerive(p);
          var st = pdpState;
          /* No real selling plan -> one-time only, so the buy box never promises a
             subscription (or a 15% "save") the product can't fulfil. */
          var hasSub = !!p.sellingPlanId;
          if (!hasSub) { st.sub = false; }
          var pdpSavePct = Number(p.price) > 0 ? Math.round((1 - parseFloat(d.subPrice) / Number(p.price)) * 100) : 0;
          var price = st.sub ? d.subPrice : p.price.toFixed(2);
          /* pdpSavePct above is derived from the product's own subscription
             price, so the label states the discount this product actually
             gives. It used to be hardcoded to 15% while every real selling plan
             is 10% monthly (7% at 60 days, 5% at 90). */
          var planLabel = st.sub ? 'Subscribe & save ' + pdpSavePct + '%' : 'One-time purchase';
          var perDay = (parseFloat(price) / 30).toFixed(2);
          var cross = PP_BY_SLUG[p.pairs[0]];
          var h = [];
          h.push('<div class="pp-pdp-inner">');
          /* breadcrumb */
          h.push('<div class="pp-pdp-crumb"><a href="/" data-pdp-close>Home</a> &nbsp;/&nbsp; <a href="#pp-shop" data-pp-shop-open="All">All Formulas</a> &nbsp;/&nbsp; ' + p.name + '</div>');
          /* top grid */
          h.push('<div class="pp-pdp-top">');
          h.push('<div class="pp-pdp-gal">');
          h.push('<div class="pp-pdp-stage">' + (p.badge ? '<span class="pp-pdp-badge">' + p.badge + '</span>' : '') + '<img src="' + PP_IMG[p.slug] + '" alt="' + p.name.replace(/"/g, '&quot;') + '"></div>');
          h.push('<div class="pp-pdp-thumbs">' + ['Bottle','Label','Facts','In use'].map(function (t, i) { return '<span class="pp-pdp-thumb' + (i === 0 ? ' is-on' : '') + '">' + t + '</span>'; }).join('') + '</div>');
          h.push('<div class="pp-pdp-chiprow"><span class="pp-pdp-chip pp-pdp-chip--tint">USP-Grade</span><span class="pp-pdp-chip pp-pdp-chip--lab">3rd-Party Tested</span><span class="pp-pdp-chip pp-pdp-chip--usa">Made in USA</span></div>');
          h.push('</div>');
          /* info column */
          h.push('<div class="pp-pdp-info">');
          h.push('<div class="pp-pdp-line">' + p.line + '</div>');
          h.push('<h1 class="pp-pdp-name">' + p.name + '</h1>');
          if (Number(p.count || 0) > 0) { h.push('<div class="pp-pdp-rate"><span class="pp-pdp-stars">' + STARS + '</span> ' + Number(p.rating).toFixed(1) + ' · ' + p.count + ' review' + (Number(p.count) === 1 ? '' : 's') + '</div>'); }
          h.push('<p class="pp-pdp-hookp">' + p.longHook + '</p>');
          h.push('<div class="pp-pdp-bens">' + p.benefits.map(function (b) { return '<div class="pp-pdp-ben"><span class="pp-check">✓</span> ' + b + '</div>'; }).join('') + '</div>');
          if (hasSub) {
            h.push('<div class="pp-pdp-plans">');
            h.push('<button type="button" class="pp-pdp-plan' + (st.sub ? ' is-on' : '') + '" data-pdp-sub="1"><div class="pp-pdp-plan-t">Subscribe' + (pdpSavePct > 0 ? ' &amp; save ' + pdpSavePct + '%' : '') + '</div><div class="pp-pdp-plan-s">$' + d.subPrice + ' / 30-day · cancel anytime</div></button>');
            h.push('<button type="button" class="pp-pdp-plan' + (!st.sub ? ' is-on' : '') + '" data-pdp-sub="0"><div class="pp-pdp-plan-t">One-time</div><div class="pp-pdp-plan-s">' + ppMoney(p.price) + ' · ships once</div></button>');
            h.push('</div>');
          }
          h.push('<div class="pp-pdp-buy">');
          h.push('<div class="pp-pdp-qty"><button type="button" class="pp-pdp-qbtn" data-pdp-dec aria-label="Decrease quantity">−</button><span class="pp-pdp-qn">' + st.qty + '</span><button type="button" class="pp-pdp-qbtn" data-pdp-inc aria-label="Increase quantity">+</button></div>');
          h.push('<button type="button" class="pp-pdp-add" data-pdp-add>Add to cart · $' + price + '</button>');
          h.push('</div>');
          h.push('<div class="pp-pdp-metar"><strong>Just $' + perDay + '/day</strong><span>·</span><span>' + p.servings + '</span><span>·</span><span>free shipping over $75</span></div>');
          if (cross) {
            h.push('<div class="pp-pdp-cross"><span class="pp-pdp-cross-img"><img src="' + PP_IMG[cross.slug] + '" alt="' + cross.name.replace(/"/g, '&quot;') + '"></span><span style="flex:1; min-width:0;"><span class="pp-pdp-cross-e" style="display:block;">Complete your protocol</span><span class="pp-pdp-cross-t" style="display:block;">Add ' + cross.name + '</span><span class="pp-pdp-cross-s" style="display:block;">Stack both and save 15% on your order.</span></span><button type="button" class="pp-pdp-addboth" data-pdp-add>Add both</button></div>');
          }
          h.push('<div class="pp-pdp-assure"><span>90-day guarantee</span><span>3rd-party tested</span><span>cGMP · Made in USA</span></div>');
          h.push('<p class="pp-pdp-fda">*These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, cure, or prevent any disease. Consult your physician before use — especially if you are pregnant, nursing, have a medical condition, or take medication.</p>');
          h.push('</div></div>');
          /* facts + COA */
          h.push('<div class="pp-pdp-mid">');
          h.push('<div class="pp-pdp-card"><h3 class="pp-pdp-h3">What’s inside</h3><p class="pp-pdp-cardsub">Every active listed individually — no proprietary blends.</p>');
          h.push('<div class="pp-facts"><div class="pp-facts-head">Supplement Facts</div><div class="pp-facts-body">');
          h.push('<div class="pp-facts-srow"><span>Serving size</span><b>' + d.servingSize + '</b></div>');
          h.push('<div class="pp-facts-srow pp-facts-srow--thick"><span>Servings per container</span><b>' + d.servingsPer + '</b></div>');
          h.push('<div class="pp-facts-cols"><span>Amount per serving</span><span>% DV</span></div>');
          h.push(d.fullFacts.map(function (f) { return '<div class="pp-facts-row"><span class="n">' + f.n + '</span><span class="a">' + f.a + '<span class="dv"> ' + f.dv + '</span></span></div>'; }).join(''));
          h.push('<p class="pp-facts-note">† Daily Value (DV) not established. Percent Daily Values are based on a 2,000 calorie diet.</p>');
          h.push('</div></div>');
          h.push('<div class="pp-pdp-otherh">Other ingredients</div><p class="pp-pdp-otherp">' + d.otherIng + '</p>');
          h.push('<div class="pp-pdp-pills"><span class="pp-pill">Non-GMO</span><span class="pp-pill">Gluten-free</span><span class="pp-pill">Vegan</span><span class="pp-pill">No fillers</span></div>');
          h.push('</div>');
          h.push('<div class="pp-pdp-side">');
          var pdpLot = PP_LOT_BY_SLUG[p.slug];
          if (pdpLot) {
            h.push(coaCardHTML(pdpLot));
            h.push('<div class="pp-pdp-coarow"><div><div class="pp-pdp-coarow-t">Read this lot’s full certificate</div><div class="pp-pdp-coarow-s">Identity, potency, heavy metals &amp; microbials.</div></div><a class="pp-pdp-viewcoa" href="#pp-transparency-page" data-pp-route="transparency">View COA</a></div>');
          } else {
            h.push('<div class="pp-coa"><div class="pp-coa-head"><div><div class="pp-coa-label">Certificate of Analysis</div><div class="pp-coa-name">' + p.name + '</div><div class="pp-coa-lot">First production lot not yet released</div></div></div><div class="pp-coa-rows"><div class="pp-coa-row"><span>The full independent-lab certificate for this formula&rsquo;s first lot will be published here the day it ships.</span></div></div></div>');
            h.push('<div class="pp-pdp-coarow"><div><div class="pp-pdp-coarow-t">Every lot ships with its certificate</div><div class="pp-pdp-coarow-s">Identity, potency, heavy metals &amp; microbials.</div></div><a class="pp-pdp-viewcoa" href="#pp-transparency-page" data-pp-route="transparency">How we test</a></div>');
          }
          h.push('</div></div>');
          /* in-action banner */
          h.push('<div class="pp-pdp-action"><img src="' + PP_IMG['_lifestyle'] + '" alt="' + ppAlt(p.name) + ' as part of a daily routine" loading="lazy"><div class="pp-pdp-action-grad"></div><div class="pp-pdp-action-cap"><div class="pp-pdp-action-t">One bottle. One job. Every day.</div><p class="pp-pdp-action-p">' + d.howTo + '</p></div></div>');
          /* built to do */
          h.push('<div class="pp-pdp-built"><h3 class="pp-pdp-built-h">What ' + p.name + ' is built to do.</h3><div class="pp-pdp-cols3">');
          h.push(d.how.map(function (hw) { return '<div class="pp-pdp-howcard"><div class="pp-pdp-howcard-no">' + hw.no + '</div><p>' + hw.b + '</p></div>'; }).join(''));
          h.push('</div></div>');
          /* ingredient carousel */
          h.push('<div class="pp-pdp-inghead"><div><div class="pp-pdp-eyebrow">Every active, and why it’s here</div><h3 class="pp-pdp-ingh3">Led by ' + p.active + '.</h3></div><a class="pp-pdp-inglib" href="#pp-ingredients" data-pp-route="ingredients">Ingredient library →</a></div>');
          h.push('<div class="pp-pdp-car"><div class="pp-pdp-car-vp"><div class="pp-pdp-car-track" data-pdp-track style="transform:translateX(-' + (st.ing * 100) + '%);">');
          h.push(d.ingredientRows.map(function (ig, i) {
            return '<div class="pp-pdp-slide"><div class="pp-pdp-slide-vis"><span class="pp-pdp-slide-chip">Active ' + (i + 1) + ' of ' + d.ingredientRows.length + '</span><img src="' + PP_IMG[p.slug] + '" alt="' + ppAlt(p.name) + '" loading="lazy"></div><div class="pp-pdp-slide-body">' + (i === 0 ? '<div class="pp-pdp-slide-key">Key active</div>' : '') + '<h4 class="pp-pdp-slide-h4">' + ig.n + '</h4><div class="pp-pdp-slide-dose">' + ig.a + '</div><p class="pp-pdp-slide-why">' + ig.why + '</p><div class="pp-pdp-slide-tags"><span class="pp-pdp-slide-tag">' + ig.studyLabel + '</span><span class="pp-pdp-slide-tag">Printed on the label</span></div></div></div>';
          }).join(''));
          h.push('</div></div>');
          h.push('<div class="pp-pdp-car-ctrl"><div class="pp-pdp-dots">' + d.ingredientRows.map(function (ig, i) { return '<button type="button" class="pp-pdp-dot' + (i === st.ing ? ' is-on' : '') + '" data-pdp-dot="' + i + '" aria-label="Slide ' + (i + 1) + '"></button>'; }).join('') + '</div>');
          h.push('<div class="pp-pdp-car-end"><span class="pp-pdp-car-pos" data-pdp-pos>' + (st.ing + 1) + ' / ' + d.ingredientRows.length + '</span><button type="button" class="pp-pdp-nav" data-pdp-prev aria-label="Previous">←</button><button type="button" class="pp-pdp-nav pp-pdp-nav--next" data-pdp-next aria-label="Next">→</button></div></div></div>');
          /* how to take it */
          h.push('<div class="pp-pdp-howto"><div class="pp-pdp-howto-l"><div class="pp-pdp-eyebrow">How to take it</div><p class="pp-pdp-howto-p">' + d.howTo + '</p><div class="pp-pdp-special"><div class="pp-pdp-special-e">Special instructions</div><p class="pp-pdp-special-p">' + d.special + '</p></div></div>');
          h.push('<div class="pp-pdp-stats"><div><div class="pp-pdp-stat-l">Supply</div><div class="pp-pdp-stat-v">' + p.servings + '</div></div><div><div class="pp-pdp-stat-l">Key active</div><div class="pp-pdp-stat-v">' + p.active + '</div></div></div></div>');
          /* capsule scale */
          h.push('<div class="pp-pdp-cap"><div class="pp-pdp-cap-head"><div class="pp-pdp-eyebrow">How big is it to swallow?</div><div class="pp-pdp-cap-sub">' + d.capsuleForm + ' · drawn to scale</div></div>');
          h.push('<div class="pp-pdp-capgrid"><div>');
          h.push('<div class="pp-pdp-caprow">');
          h.push('<div class="pp-pdp-capcol"><div class="pp-cappill" style="width:' + d.capsuleWidthMm + 'mm;"><div class="pp-cappill-shine"></div></div><div class="pp-pdp-capname">' + p.name + '</div><div class="pp-pdp-caplen">' + d.capsuleLenLabel + '</div></div>');
          h.push('<div class="pp-pdp-capcol pp-pdp-capcol--ref"><div style="width:19mm; height:8mm; border-radius:99.9rem; background:#c7a86a; box-shadow:inset 0 -3px 8px rgba(0,0,0,.18), 0 6px 14px -8px rgba(35,43,51,.4);"></div><div class="pp-pdp-capname pp-pdp-capname--ref">Standard fish-oil softgel</div><div class="pp-pdp-caplen">for reference · 19 mm</div></div>');
          h.push('<div class="pp-pdp-capcol pp-pdp-capcol--ref"><div style="width:9mm; height:9mm; border-radius:50%; background:#b7742f; box-shadow:inset 0 -3px 8px rgba(0,0,0,.22), 0 6px 14px -8px rgba(35,43,51,.4);"></div><div class="pp-pdp-capname pp-pdp-capname--ref">A coffee bean</div><div class="pp-pdp-caplen">for reference · 9 mm</div></div>');
          h.push('</div>');
          h.push('<div class="pp-pdp-ruler"></div><div class="pp-pdp-rulernote">Each tick = 1 cm. ' + p.name + ' is a ' + d.capsuleLabel + ' capsule — about the size of a common fish-oil softgel.</div>');
          h.push('</div>');
          h.push('<div class="pp-pdp-cap-stats"><div><div class="pp-pdp-stat-l">Form</div><div class="pp-pdp-stat-v">' + d.capsuleForm + '</div></div><div><div class="pp-pdp-stat-l">Per serving</div><div class="pp-pdp-stat-v">' + d.servingSize + '</div></div></div>');
          h.push('</div></div>');
          /* what to expect */
          h.push('<div class="pp-pdp-expect"><div class="pp-pdp-eyebrow">What to expect</div><h3 class="pp-pdp-expect-h">This is a protocol, not a quick fix.</h3><div class="pp-pdp-cols3">');
          h.push(d.timeline.map(function (tl) { return '<div class="pp-pdp-tl"><div class="pp-pdp-tl-bar"></div><div class="pp-pdp-tl-top"><span class="pp-pdp-tl-no">' + tl.no + '</span><span class="pp-pdp-tl-wk">' + tl.wk + '</span></div><div class="pp-pdp-tl-t">' + tl.t + '</div><p class="pp-pdp-tl-b">' + tl.b + '</p></div>'; }).join(''));
          h.push('</div></div>');
          /* fit */
          h.push('<div class="pp-pdp-fitgrid">');
          h.push('<div class="pp-pdp-fit pp-pdp-fit--yes"><h3 class="pp-pdp-fit-h">A good fit if…</h3><div class="pp-pdp-fit-list">' + d.whoFor.map(function (w) { return '<div class="pp-pdp-fit-row"><span class="pp-check">✓</span> ' + w + '</div>'; }).join('') + '</div></div>');
          h.push('<div class="pp-pdp-fit pp-pdp-fit--no"><h3 class="pp-pdp-fit-h">Maybe not if…</h3><div class="pp-pdp-fit-list">' + d.whoNot.map(function (w) { return '<div class="pp-pdp-fit-row"><span class="pp-dash">–</span> ' + w + '</div>'; }).join('') + '</div></div>');
          h.push('</div>');
          /* vs table */
          h.push('<div class="pp-pdp-vs"><div class="pp-pdp-vs-e">Precise Protocols vs. a typical “support” blend</div><div class="pp-pdp-vs-rows">');
          h.push('<div class="pp-pdp-vsrow pp-pdp-vsrow--head"><span></span><span class="us">This formula</span><span class="them">Typical blend</span></div>');
          h.push(d.vsRows.map(function (v) { return '<div class="pp-pdp-vsrow"><span class="lbl">' + v.label + '</span><span class="us">' + v.us + '</span><span class="them">' + v.them + '</span></div>'; }).join(''));
          h.push('</div></div>');
          /* reviews — summary only, and only when the product actually has real
             reviews. The per-review demo text is fabricated, so it is never
             rendered here (16 CFR Part 465); real review content lives on the
             product page. */
          if (Number(p.count || 0) > 0) {
            h.push('<div class="pp-pdp-revs"><div class="pp-pdp-revhead"><span class="pp-pdp-stars">' + STARS + '</span><span class="pp-pdp-rev-score">' + Number(p.rating).toFixed(1) + ' / 5</span><span class="pp-pdp-rev-from">' + p.count + ' review' + (Number(p.count) === 1 ? '' : 's') + '</span></div></div>');
          }
          /* faqs */
          h.push('<div class="pp-pdp-faqgrid"><h3 class="pp-pdp-faq-h">Questions,<br>answered.</h3><div class="pp-pdp-faqs">');
          h.push(d.faqs.map(function (f) { return '<div class="pp-pdp-faq"><div class="pp-pdp-faq-q">' + f.q + '</div><p class="pp-pdp-faq-a">' + f.a + '</p></div>'; }).join(''));
          h.push('</div></div>');
          /* pairs */
          h.push('<div class="pp-pdp-pairs"><h3 class="pp-pdp-pairs-h">Pairs well with</h3><div class="pp-pdp-cols3">');
          h.push(p.pairs.map(function (s) {
            var q = PP_BY_SLUG[s]; if (!q) { return ''; }
            return '<a class="pp-pdp-pair" href="#pp-product/' + q.slug + '" data-pp-product="' + q.slug + '"><span class="pp-pdp-pair-img"><img src="' + PP_IMG[q.slug] + '" alt="' + q.name.replace(/"/g, '&quot;') + '"></span><span class="pp-pdp-pair-body"><span class="pp-pdp-pair-name" style="display:block;">' + q.name + '</span><span class="pp-pdp-pair-price" style="display:block;">' + ppMoney(q.price) + '</span></span></a>';
          }).join(''));
          h.push('</div></div>');
          h.push('</div>');
          /* sticky bar */
          h.push('<div class="pp-pdp-bar"><div class="pp-pdp-bar-thumb"></div><div class="pp-pdp-bar-mid"><div class="pp-pdp-bar-name">' + p.name + '</div><div class="pp-pdp-bar-sub">' + planLabel + ' · ' + p.servings + '</div></div><div class="pp-pdp-bar-price">$' + price + '</div><button type="button" class="pp-pdp-bar-add" data-pdp-add>Add to cart</button></div>');
          return h.join('');
        };

        var renderPdp = function (p) {
          pdpMount.setAttribute('style', '--pt:' + p.tint + '; --pth:' + ppShade(p.tint, -0.16) + '; --pts:' + ppSoft(p.tint, 0.09) + '; --ptb:' + ppSoft(p.tint, 0.45) + ';');
          pdpMount.innerHTML = pdpHTML(p);
        };
        /* Qty only appears in one span and the shown price is per unit, so a full
           re-render (which resets scroll and focus) is not needed for the steppers. */
        var syncPdpQty = function () {
          var qn = pdpMount.querySelector('.pp-pdp-qn');
          if (qn) { qn.textContent = pdpState.qty; }
        };

        /* --- Shop / All formulas view --- */
        var renderShop = function () {
          var key = shopState.concern;
          var visible = key === 'All' ? PP_PRODUCTS : PP_PRODUCTS.filter(function (p) { return p.ck === key; });
          var h = [];
          h.push('<div class="pp-shop-inner">');
          h.push('<div class="pp-pdp-crumb"><a href="/" data-pp-shop-close>Home</a> &nbsp;/&nbsp; All Formulas</div>');
          h.push('<h1 class="pp-shop-h1">All formulas</h1>');
          h.push('<p class="pp-shop-sub">Single-purpose formulas, each with one clear job. Every active listed individually, at a clinically-studied dose — and the range keeps growing.</p>');
          h.push('<div class="pp-shop-tabs">');
          h.push('<button type="button" class="pp-shop-tab' + (key === 'All' ? ' is-on' : '') + '" style="--ct:#232b33;" data-pp-shop-tab="All">All</button>');
          h.push(PP_CONCERNS.map(function (c) {
            return '<button type="button" class="pp-shop-tab' + (key === c.key ? ' is-on' : '') + '" style="--ct:' + c.tint + ';" data-pp-shop-tab="' + c.key + '">' + c.name + '</button>';
          }).join(''));
          h.push('</div>');
          /* A pp_concern key with no product mapped to it (the catalog below
             maps products by ck) would otherwise render an unexplained blank. */
          if (!visible.length) {
            var emptyName = PP_CONCERN_BY_KEY[key] ? PP_CONCERN_BY_KEY[key].name : 'this concern';
            h.push('<p class="pp-shop-empty">No formulas are listed under ' + esc(emptyName) + ' yet. <button type="button" class="pp-shop-empty-all" data-pp-shop-tab="All">See all formulas</button></p>');
            h.push('</div>');
            shopMount.innerHTML = h.join('');
            return;
          }
          h.push('<div class="pp-shop-grid">');
          /* The card is a div, not a link: the tier and plan controls inside it
             are buttons, and a button inside an anchor is neither valid nor
             clickable. The image and title carry the route instead. */
          h.push(visible.map(function (p) {
            var f = buyFigures(p);
            var stars = '';
            for (var s = 1; s <= 5; s++) {
              stars += s <= Math.round(Number(p.rating || 0)) ? '&#9733;' : '<span class="pp-star-off">&#9733;</span>';
            }
            var plan = function (mode, label, price, note) {
              var on = (mode === 'once') === f.onceSel;
              return '<button type="button" class="pp-plan' + (on ? ' is-on' : '') + '" data-pp-mode="' + p.slug + '|' + mode + '">'
                + '<span class="pp-plan-top"><span class="pp-plan-name"><span class="pp-plan-dot"></span>' + label + '</span>'
                + '<span class="pp-plan-price">' + price + '</span></span>'
                + '<span class="pp-plan-note">' + note + '</span></button>';
            };
            return '<div class="pp-card" data-pp-card="' + p.slug + '" style="--t:' + p.tint + '; --tw:' + ppSoft(p.tint, 0.07) + ';">'
              + '<a class="pp-card-img" href="#pp-product/' + p.slug + '" data-pp-product="' + p.slug + '">' + (p.badge ? '<span class="pp-badge">' + p.badge + '</span>' : '') + '<img src="' + PP_IMG[p.slug] + '" alt="' + p.name.replace(/"/g, '&quot;') + '" loading="lazy"></a>'
              + '<div class="pp-card-body">'
              + '<span class="pp-card-line">' + p.line + '</span>'
              + '<a class="pp-card-name" href="#pp-product/' + p.slug + '" data-pp-product="' + p.slug + '">' + p.name + '</a>'
              + (Number(p.count || 0) > 0 ? ('<span class="pp-card-rate"><span class="pp-stars pp-stars--sm">' + stars + '</span>'
              + '<span class="pp-card-rate-n">' + Number(p.rating || 0).toFixed(1) + '</span>'
              + '<span class="pp-card-rate-c">(' + Number(p.count || 0).toLocaleString() + ')</span></span>') : '')
              + '<span class="pp-card-hook">' + p.hook + '</span>'
              + '<span class="pp-card-active">' + p.active + '</span>'
              + (f.hasSub
                ? ('<div class="pp-plans">'
                  + plan('sub', 'Subscribe' + (f.savePct > 0 ? ' &amp; save ' + f.savePct + '%' : ''), f.priceSub, 'Ships every month · skip or cancel anytime')
                  + plan('once', 'Buy once', f.priceOnce, 'One shipment, no plan')
                  + '</div>')
                : '<div class="pp-card-onetime">One-time purchase · ' + f.priceOnce + '</div>')
              + '<div class="pp-card-meta"><span>' + f.perDay + '</span><span>' + f.shipNote + '</span></div>'
              + '<button type="button" class="pp-card-add pp-card-add--buy" data-pp-toast>' + (f.onceSel ? 'Add &mdash; ' + f.priceOnce : 'Subscribe &mdash; ' + f.priceSub) + '</button>'
              + '<div class="pp-card-note">' + f.subNote + '</div>'
              + '</div></div>';
          }).join(''));
          h.push('</div></div>');
          shopMount.innerHTML = h.join('');
        };
        var shopHash = function () { return '#pp-shop' + (shopState.concern !== 'All' ? '/' + shopState.concern : ''); };
        var showShop = function (key) {
          if (atHome()) { savedScroll = window.pageYOffset || document.documentElement.scrollTop || 0; }
          shopState.concern = key && PP_CONCERN_BY_KEY[key] ? key : 'All';
          pdpState.slug = null;
          pageState.view = null;
          clearPageClasses();
          root.classList.remove('is-pdp-open');
          renderShop();
          shopState.open = true;
          root.classList.add('is-shop-open');
          window.scrollTo(0, 0);
        };
        var hideShop = function () {
          if (!shopState.open) { return; }
          shopState.open = false;
          root.classList.remove('is-shop-open');
          window.scrollTo(0, savedScroll);
        };
        /* Real-URL routing: each view can map to a real Shopify page (window.__PP_ROUTES,
           emitted by the section; entries are null until the page exists in admin).
           Non-null -> pushState the real path. Null -> legacy hash routing unchanged. */
        var ROUTE_KEY = { transp: 'transparency', ing: 'ingredients', bundles: 'bundles', about: 'about', quiz: 'finder', shop: 'shop', proto: 'protocol', cart: 'cart' };
        var routeFor = function (view) {
          var k = ROUTE_KEY[view];
          var r = (window.__PP_ROUTES && k) ? window.__PP_ROUTES[k] : null;
          return (typeof r === 'string' && r) ? r : null;
        };
        var normPath = function (p) { return ((p || '/').replace(/\/+$/, '')) || '/'; };
        var viewForPath = function (path) {
          var np = normPath(path);
          for (var v in ROUTE_KEY) {
            if (ROUTE_KEY.hasOwnProperty(v)) {
              var r = routeFor(v);
              if (r && normPath(r) === np) { return v; }
            }
          }
          return null;
        };
        var concernFromSearch = function () {
          var m = (window.location.search || '').match(/[?&]concern=([a-z]+)/);
          return m ? m[1] : null;
        };
        var shopUrl = function () {
          var p = routeFor('shop');
          return p ? p + (shopState.concern !== 'All' ? '?concern=' + shopState.concern : '') : null;
        };
        /* Leaving a view for "home": on a real view path, navigate to /; else just clear the hash */
        var goHomeUrl = function () {
          if (viewForPath(window.location.pathname)) { histPush({ ppHome: 1 }, (window.ZPTheme && ZPTheme.root) || '/'); }
          else { histReplace(null, window.location.pathname + window.location.search); }
        };
        var openShop = function (key) {
          showShop(key);
          var p = shopUrl();
          if (p) { histPush({ ppView: 'shop' }, p); }
          else { histPush({ ppShop: shopState.concern }, shopHash()); }
        };
        var closeShop = function () {
          hideShop();
          try {
            if (history.state && (history.state.ppShop || history.state.ppView === 'shop')) { history.back(); return; }
          } catch (err) {}
          goHomeUrl();
        };

        /* --- Route pages: transparency / ingredients / bundles / about --- */
        var pageState = { view: null };
        /* Verified by default, like the prototype (lotVerified = !scanning): the
           page opens on a real lot (PP_LOTS[0]) with its checks cascaded in and
           the ✓ VERIFIED stamp landed. A failed lookup clears it back to false. */
        var transpState = { entry: PP_LOTS[0], query: '', scanning: false, verified: false, notFound: '' };
        var ingState = { q: '' };
        var bundlesState = { builder: [] };
        var aboutState = { sent: false };
        var lotTimer = null;
        var esc = function (s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;'); };

        /* Renders a COA card for a known lot registry entry only. Identity and
           potency read off the lot's product — the lead active's botanical name
           and its standardization (the "(45% fatty acids)" part), so PP-2416
           reads "Identity — Saw Palmetto / Potency — 45% fatty acids". The metals,
           microbial and gluten panels are the same checklist every lot passes. */
        var coaCardHTML = function (entry) {
          var prod = PP_BY_SLUG[entry[3]];
          var identity = 'Identity — botanical & actives';
          var potency = 'Potency — label claim';
          if (prod && prod.facts && prod.facts[0]) {
            var lead = String(prod.facts[0][0] || '');
            var std = lead.match(/^(.*?)\s*\(([^)]+)\)\s*$/);
            if (std) {
              identity = 'Identity — ' + std[1].trim();
              potency = 'Potency — ' + std[2].trim();
            } else {
              identity = 'Identity — ' + lead.trim();
              potency = 'Potency — ' + (prod.facts[0][1] || 'label claim');
            }
          }
          return '<div class="pp-coa"><div class="pp-coa-head"><div><div class="pp-coa-label">Certificate of Analysis</div><div class="pp-coa-name">' + esc(entry[1]) + '</div><div class="pp-coa-lot">Lot ' + esc(entry[0]) + ' · Tested ' + esc(entry[2]) + ' · Independent lab</div></div><span class="pp-coa-pass">PASSED</span></div><div class="pp-coa-rows">'
            + [[identity,'Conforms'],[potency,'Meets spec'],['Heavy metals (Pb, As, Cd, Hg)','Below limits'],['Microbials & mold','Below limits'],['Gluten','Not detected']].map(function (r) { return '<div class="pp-coa-row"><span>' + esc(r[0]) + '</span><span class="pp-coa-val">' + r[1] + '<span class="pp-coa-check">✓</span></span></div>'; }).join('')
            + '</div></div>';
        };
        /* Seal badges mirror the transparency section's list (window.__PP_SEAL,
           emitted by pp-home.liquid): real badge images, editable in the theme
           editor. If none were emitted, fall back to plain text-circle seals. */
        var sealsHTML = (function () {
          var seals = window.__PP_SEAL;
          if (Object.prototype.toString.call(seals) === '[object Array]' && seals.length) {
            return '<div class="pp-seals">' + seals.map(function (s) {
              return '<div class="pp-seal"><span class="pp-seal-ring pp-seal-ring--img"><img src="' + s.img + '" alt="' + esc(s.label) + '" title="' + esc(s.label) + '"></span><span class="pp-seal-l">' + esc(s.label) + '</span></div>';
            }).join('') + '</div>';
          }
          return '<div class="pp-seals"><div class="pp-seal"><span class="pp-seal-ring">USA</span><span class="pp-seal-l">Made in USA</span></div><div class="pp-seal"><span class="pp-seal-ring">cGMP</span><span class="pp-seal-l">cGMP facility</span></div><div class="pp-seal"><span class="pp-seal-ring">LAB</span><span class="pp-seal-l">Lab tested</span></div><div class="pp-seal"><span class="pp-seal-ring pp-seal-ring--sm">NON GMO</span><span class="pp-seal-l">Non-GMO</span></div></div>';
        })();

        var pageMounts = {
          transp: root.querySelector('[data-pp-page-render="transp"]'),
          ing: root.querySelector('[data-pp-page-render="ing"]'),
          bundles: root.querySelector('[data-pp-page-render="bundles"]'),
          about: root.querySelector('[data-pp-page-render="about"]'),
          quiz: root.querySelector('[data-pp-page-render="quiz"]'),
          proto: root.querySelector('[data-pp-page-render="proto"]'),
          stack: root.querySelector('[data-pp-page-render="stack"]'),
          cart: root.querySelector('[data-pp-page-render="cart"]')
        };

        /* --- Finder quiz state (persisted like the prototype's pp_state) --- */
        var PP_QF_SYMPTOMS = [
          { label:'Waking up during the night', ck:'sleep' },
          { label:'Racing mind, hard to wind down', ck:'sleep' },
          { label:'Low energy through the afternoon', ck:'longevity' },
          { label:'Bloating or irregular digestion', ck:'gut' },
          { label:'Heartburn or gut discomfort', ck:'gut' },
          { label:'Catch every cold going around', ck:'immune' },
          { label:'Weak or frequent urination', ck:'prostate' },
          { label:'Thinning hair or brittle nails', ck:'hair' },
          { label:'Feeling older than my age', ck:'longevity' },
          { label:'Everyday stress and tension', ck:'sleep' }
        ];
        var PP_QF_LIFESTYLE = [
          { label:'Very active / training', ck:'longevity' },
          { label:'Poor or short sleep', ck:'sleep' },
          { label:'High daily stress', ck:'sleep' },
          { label:'Frequent traveler', ck:'immune' },
          { label:'Mostly plant-based', ck:'longevity' },
          { label:'Desk-bound most days', ck:'gut' }
        ];
        var PP_QF_PRIORITIES = ['Clinically-studied doses','A clean label I can trust','Third-party test results','Best value for money','Keeping it simple'];
        var PP_QF_TAKING = ['Nothing yet','Multivitamin','Fish oil / Omega-3','Vitamin D','Magnesium','Probiotic'];
        var PP_QF_AGES = ['35–44','45–54','55–64','65+'];
        var PP_QF_FORMATS = [['caps','Capsules','Quick, no taste'],['powder','Powder / mix','Blend into water'],['any','No preference','Show me both']];
        var PP_QF_BUDGETS = [['1','Under $50 / mo','A focused 1–2 formulas'],['2','$50–$100 / mo','A 2–3 formula stack'],['3','$100+ / mo','A full daily protocol']];
        var PP_QF_READINESS = [['ready','I’m ready to start now','Add my protocol to the cart'],['comparing','Comparing a few options','Save it while I decide'],['research','Just researching for now','No pressure — I’ll learn as I go']];
        var PP_QF_CADENCE = [['30','30 days','Monthly'],['60','60 days','Every 2 months'],['90','90 days','Every 3 months']];
        var PP_QF_STEPLABELS = ['Step 1 of 10 · Your goals','Step 2 of 10 · What you feel','Step 3 of 10 · Your age','Step 4 of 10 · Your lifestyle','Step 5 of 10 · What matters to you','Step 6 of 10 · How you like to take it','Step 7 of 10 · Current supplements','Step 8 of 10 · Your budget','Step 9 of 10 · Readiness','Step 10 of 10 · Delivery'];

        var finderState = { step: 0, goals: [], symptoms: [], age: '', lifestyle: [], priorities: [], format: '', taking: [], budget: '', readiness: '', cadence: '30', email: '', resumeDismissed: false };
        try {
          var ppSaved = JSON.parse(window.localStorage.getItem('pp_state') || '{}');
          ['goals','symptoms','lifestyle','priorities','taking'].forEach(function (k) {
            if (Object.prototype.toString.call(ppSaved[k]) === '[object Array]') { finderState[k] = ppSaved[k]; }
          });
          ['age','format','budget','readiness','cadence','email'].forEach(function (k) {
            if (typeof ppSaved[k] === 'string' && ppSaved[k]) { finderState[k] = ppSaved[k]; }
          });
          if (typeof ppSaved.step === 'number') { finderState.step = Math.max(0, Math.min(9, ppSaved.step)); }
          finderState.resumeDismissed = !!ppSaved.resumeDismissed;
        } catch (err) {}
        /* Saved goals outlive a pp_concern edit: drop any key that no longer
           maps to a live concern, so the banner, quiz and protocol agree. */
        finderState.goals = finderState.goals.filter(function (k) { return !!PP_CONCERN_BY_KEY[k]; }).slice(0, 3);
        var updateResume = function () {
          var el = root.querySelector('[data-pp-resume]');
          if (!el) { return; }
          var show = (finderState.goals.length > 0 || finderState.symptoms.length > 0)
            && !finderState.resumeDismissed
            && pageState.view !== 'quiz' && pageState.view !== 'proto';
          if (show) {
            var s = el.querySelector('[data-pp-resume-summary]');
            if (s) {
              s.textContent = finderState.goals.length
                ? finderState.goals.map(function (k) { return PP_CONCERN_BY_KEY[k] ? PP_CONCERN_BY_KEY[k].name : k; }).join(', ')
                : 'your answers';
            }
            el.removeAttribute('hidden');
          } else {
            el.setAttribute('hidden', '');
          }
        };
        /* --- Finder banner goal cards (question 1, inline on the homepage) --- */
        var GOAL_CAP = 3;
        var goalNoteDefault = null;
        var syncBannerGoals = function () {
          var picked = finderState.goals;
          Array.prototype.forEach.call(root.querySelectorAll('.pp-finder-goals [data-pp-q-goal]'), function (el) {
            var on = picked.indexOf(el.getAttribute('data-pp-q-goal')) > -1;
            el.classList.toggle('is-on', on);
            el.setAttribute('aria-pressed', on ? 'true' : 'false');
            /* At the cap the unpicked cards read as unavailable, instead of
               silently doing nothing when clicked. */
            var capped = !on && picked.length >= GOAL_CAP;
            el.classList.toggle('is-capped', capped);
            if (capped) { el.setAttribute('aria-disabled', 'true'); }
            else { el.removeAttribute('aria-disabled'); }
          });
          var note = root.querySelector('[data-pp-goal-note]');
          if (!note) { return; }
          if (goalNoteDefault === null) { goalNoteDefault = note.textContent; }
          note.textContent = picked.length
            ? picked.length + ' of ' + GOAL_CAP + ' picked · start the finder to fine-tune.'
            : goalNoteDefault;
        };
        var toggleGoal = function (key) {
          if (!key || !PP_CONCERN_BY_KEY[key]) { return; }
          var picked = finderState.goals;
          if (picked.indexOf(key) > -1) {
            finderState.goals = picked.filter(function (x) { return x !== key; });
          } else if (picked.length < GOAL_CAP) {
            finderState.goals = picked.concat([key]);
          } else {
            return; /* at the cap — the card is already marked unavailable */
          }
          /* Editing question 1 puts you back on question 1; later answers persist. */
          finderState.step = 0;
          saveFinder();
        };
        var saveFinder = function () {
          try {
            window.localStorage.setItem('pp_state', JSON.stringify({
              step: finderState.step, goals: finderState.goals, symptoms: finderState.symptoms,
              age: finderState.age, lifestyle: finderState.lifestyle, priorities: finderState.priorities,
              format: finderState.format, taking: finderState.taking, budget: finderState.budget,
              readiness: finderState.readiness, cadence: finderState.cadence, email: finderState.email,
              resumeDismissed: finderState.resumeDismissed
            }));
          } catch (err) {}
          updateResume();
          syncBannerGoals();
        };

        var renderQuiz = function () {
          var st = finderState;
          var h = [];
          var chk = function (on) { return on ? '✓' : ''; };
          h.push('<div class="pp-q-inner">');
          h.push('<div class="pp-q-bars">' + PP_QF_STEPLABELS.map(function (_, i) { return '<span class="pp-q-bar' + (i <= st.step ? ' is-on' : '') + '"></span>'; }).join('') + '</div>');
          h.push('<div class="pp-q-steplabel">' + PP_QF_STEPLABELS[st.step] + '</div>');
          if (st.step === 0) {
            h.push('<h1 class="pp-q-h1">What do you want to work on?</h1><p class="pp-q-sub">Pick up to three. We’ll match formulas to each.</p><div class="pp-q-grid">');
            h.push(PP_CONCERNS.map(function (c) {
              var on = st.goals.indexOf(c.key) > -1;
              return '<button type="button" class="pp-q-card pp-q-goalcard' + (on ? ' is-on' : '') + '"' + (on ? ' style="border-color:' + c.tint + ';"' : '') + ' data-pp-qg="' + c.key + '"><span><span class="pp-q-card-t">' + c.name + '</span><span class="pp-q-card-s" style="display:block;">' + c.sub + '</span></span><span class="pp-q-radio">' + chk(on) + '</span></button>';
            }).join(''));
            h.push('</div>');
          } else if (st.step === 1) {
            h.push('<h1 class="pp-q-h1">Which of these sound like you?</h1><p class="pp-q-sub">Select any that apply — we use these to fine-tune your match. Skip anything that doesn’t fit.</p><div class="pp-q-grid">');
            h.push(PP_QF_SYMPTOMS.map(function (s, i) {
              var on = st.symptoms.indexOf(s.label) > -1;
              return '<button type="button" class="pp-q-chk' + (on ? ' is-on' : '') + '" data-pp-qs="' + i + '"><span>' + s.label + '</span><span class="pp-q-check">' + chk(on) + '</span></button>';
            }).join(''));
            h.push('</div>');
          } else if (st.step === 2) {
            h.push('<h1 class="pp-q-h1">How old are you?</h1><p class="pp-q-sub">Needs shift with the decades — this helps us prioritize.</p><div class="pp-q-grid">');
            h.push(PP_QF_AGES.map(function (a, i) {
              var on = st.age === a;
              return '<button type="button" class="pp-q-age' + (on ? ' is-on' : '') + '" data-pp-qa="' + i + '">' + a + '</button>';
            }).join(''));
            h.push('</div>');
          } else if (st.step === 3) {
            h.push('<h1 class="pp-q-h1">What describes your day-to-day?</h1><p class="pp-q-sub">Select any that apply — lifestyle shapes what your body needs.</p><div class="pp-q-grid">');
            h.push(PP_QF_LIFESTYLE.map(function (l, i) {
              var on = st.lifestyle.indexOf(l.label) > -1;
              return '<button type="button" class="pp-q-chk' + (on ? ' is-on' : '') + '" data-pp-ql="' + i + '"><span>' + l.label + '</span><span class="pp-q-check">' + chk(on) + '</span></button>';
            }).join(''));
            h.push('</div>');
          } else if (st.step === 4) {
            h.push('<h1 class="pp-q-h1">What matters most to you?</h1><p class="pp-q-sub">So we lead with what you care about — pick as many as you like.</p><div class="pp-q-pills">');
            h.push(PP_QF_PRIORITIES.map(function (p, i) {
              var on = st.priorities.indexOf(p) > -1;
              return '<button type="button" class="pp-q-pill' + (on ? ' is-on' : '') + '" data-pp-qp="' + i + '">' + p + (on ? ' <span class="pp-q-pillcheck">✓</span>' : '') + '</button>';
            }).join(''));
            h.push('</div>');
          } else if (st.step === 5) {
            h.push('<h1 class="pp-q-h1">How do you like to take it?</h1><p class="pp-q-sub">We’ll favor formats you’ll actually stick with.</p><div class="pp-q-col">');
            h.push(PP_QF_FORMATS.map(function (f) {
              var on = st.format === f[0];
              return '<button type="button" class="pp-q-card' + (on ? ' is-on' : '') + '" data-pp-qf="' + f[0] + '"><span><span class="pp-q-card-t">' + f[1] + '</span><span class="pp-q-card-s" style="display:block;">' + f[2] + '</span></span><span class="pp-q-radio">' + chk(on) + '</span></button>';
            }).join(''));
            h.push('</div>');
          } else if (st.step === 6) {
            h.push('<h1 class="pp-q-h1">What are you already taking?</h1><p class="pp-q-sub">So we can flag overlaps and avoid doubling up on actives.</p><div class="pp-q-pills">');
            h.push(PP_QF_TAKING.map(function (t, i) {
              var on = st.taking.indexOf(t) > -1;
              return '<button type="button" class="pp-q-pill pp-q-pill--dark' + (on ? ' is-on' : '') + '" data-pp-qt="' + i + '">' + t + '</button>';
            }).join(''));
            h.push('</div>');
          } else if (st.step === 7) {
            h.push('<h1 class="pp-q-h1">What’s your monthly budget?</h1><p class="pp-q-sub">We’ll size your protocol to fit — no upsell games.</p><div class="pp-q-col">');
            h.push(PP_QF_BUDGETS.map(function (b) {
              var on = st.budget === b[0];
              return '<button type="button" class="pp-q-card' + (on ? ' is-on' : '') + '" data-pp-qb="' + b[0] + '"><span><span class="pp-q-card-t">' + b[1] + '</span><span class="pp-q-card-s" style="display:block;">' + b[2] + '</span></span><span class="pp-q-radio">' + chk(on) + '</span></button>';
            }).join(''));
            h.push('</div>');
          } else if (st.step === 8) {
            h.push('<h1 class="pp-q-h1">Where are you in your decision?</h1><p class="pp-q-sub">No pressure — this just tailors what happens next.</p><div class="pp-q-col">');
            h.push(PP_QF_READINESS.map(function (r) {
              var on = st.readiness === r[0];
              return '<button type="button" class="pp-q-card' + (on ? ' is-on' : '') + '" data-pp-qr="' + r[0] + '"><span><span class="pp-q-card-t">' + r[1] + '</span><span class="pp-q-card-s" style="display:block;">' + r[2] + '</span></span><span class="pp-q-radio">' + chk(on) + '</span></button>';
            }).join(''));
            h.push('</div>');
          } else {
            /* "save 15%" here was not backed by anything: the selling plans on
               every product are 10% monthly, 7% every 2 months, 5% every 3.
               "up to 10%" stays true whichever cadence is picked. */
            h.push('<h1 class="pp-q-h1">How often should we ship?</h1><p class="pp-q-sub">Subscriptions save up to 10% — change or cancel anytime.</p><div class="pp-q-grid3">');
            h.push(PP_QF_CADENCE.map(function (c) {
              var on = st.cadence === c[0];
              return '<button type="button" class="pp-q-cadence' + (on ? ' is-on' : '') + '" data-pp-qc="' + c[0] + '"><span class="pp-q-cadence-t" style="display:block;">' + c[1] + '</span><span class="pp-q-cadence-s" style="display:block;">' + c[2] + '</span></button>';
            }).join(''));
            h.push('</div>');
            h.push('<input type="email" class="pp-rt-input pp-q-email" data-pp-q-email value="' + esc(st.email || '') + '" placeholder="Email for your protocol (optional)" autocomplete="email">');
          }
          /* Step 0 requires at least one goal — everything downstream keys off it. */
          var nextDisabled = (st.step === 0 && !st.goals.length);
          h.push('<div class="pp-q-foot"><button type="button" class="pp-q-back" data-pp-q-back>' + (st.step > 0 ? '← Back' : '← Home') + '</button><button type="button" class="pp-q-next" data-pp-q-next' + (nextDisabled ? ' disabled aria-disabled="true" title="Pick at least one goal to continue"' : '') + '>' + (st.step < 9 ? 'Continue' : 'See my protocol') + '</button></div>');
          h.push('</div>');
          if (pageMounts.quiz) { pageMounts.quiz.innerHTML = h.join(''); }
        };

        var computeProtocol = function () {
          var st = finderState;
          var scoreMap = {};
          st.goals.forEach(function (k) { scoreMap[k] = (scoreMap[k] || 0) + 2; });
          st.symptoms.forEach(function (lbl) {
            PP_QF_SYMPTOMS.forEach(function (x) { if (x.label === lbl) { scoreMap[x.ck] = (scoreMap[x.ck] || 0) + 1; } });
          });
          st.lifestyle.forEach(function (lbl) {
            PP_QF_LIFESTYLE.forEach(function (x) { if (x.label === lbl) { scoreMap[x.ck] = (scoreMap[x.ck] || 0) + 1; } });
          });
          var ranked = [];
          for (var k in scoreMap) { if (scoreMap.hasOwnProperty(k) && scoreMap[k] > 0) { ranked.push(k); } }
          ranked.sort(function (a, b) { return scoreMap[b] - scoreMap[a]; });
          /* Honor the format answer: "Capsules" never recommends a powder. */
          var matchesFormat = function (p) { return p.available && !(st.format === 'caps' && p.form === 'powder'); };
          var recSlugs = [];
          ranked.forEach(function (key) {
            var first = null;
            PP_PRODUCTS.forEach(function (p) { if (!first && p.ck === key && matchesFormat(p)) { first = p; } });
            if (first && recSlugs.indexOf(first.slug) < 0) { recSlugs.push(first.slug); }
          });
          if (!recSlugs.length) {
            recSlugs = PP_PRODUCTS.filter(function (p) { return p.badge === 'Best seller' && matchesFormat(p); }).map(function (p) { return p.slug; });
          }
          var cap = st.budget === '1' ? 2 : (st.budget === '3' ? 4 : 3);
          recSlugs = recSlugs.slice(0, cap);
          var items = recSlugs.map(function (s) { return PP_BY_SLUG[s]; });
          var monthly = items.reduce(function (a, p) { return a + p.price; }, 0);
          var total = monthly;
          var topNames = ranked.slice(0, 3).map(function (key) { return PP_CONCERN_BY_KEY[key] ? PP_CONCERN_BY_KEY[key].name : key; });
          var subBits = ['Single-purpose formulas matched to your ' + (st.symptoms.length ? 'goals and symptoms' : 'goals') + ', at clinically-studied doses.'];
          if (st.priorities.indexOf('A clean label I can trust') > -1 || st.priorities.indexOf('Clinically-studied doses') > -1) { subBits.push('No proprietary blends, dosed to the research.'); }
          if (st.readiness === 'research') { subBits.push('No rush — save it and start whenever you’re ready.'); }
          else if (st.readiness === 'ready') { subBits.push('Ready when you are — add it to your cart in one tap.'); }
          /* Cross-check "already taking" answers against each formula's listed
             actives — this is the overlap flagging the quiz copy promises. */
          var takingKeywords = { 'Vitamin D': ['vitamin d'], 'Magnesium': ['magnesium'], 'Probiotic': ['probiotic', 'cfu'] };
          var takingOverlaps = [];
          st.taking.forEach(function (t) {
            var kws = takingKeywords[t];
            if (!kws) { return; }
            items.forEach(function (p) {
              p.facts.forEach(function (f) {
                var name = String(f[0]).toLowerCase();
                kws.forEach(function (kw) {
                  if (name.indexOf(kw) > -1) {
                    takingOverlaps.push('You already take ' + t + ' — ' + p.name + ' includes ' + f[0] + ' (' + f[1] + ').');
                  }
                });
              });
            });
          });
          return {
            items: items,
            title: topNames.length ? 'Built around ' + topNames.join(', ') : 'Your recommended protocol',
            sub: subBits.join(' '),
            monthly: monthly.toFixed(2),
            total: total.toFixed(2),
            savings: (monthly - total).toFixed(2),
            perDay: (total / 30).toFixed(2),
            overlaps: ppOverlaps(recSlugs).concat(takingOverlaps)
          };
        };

        var renderProto = function () {
          var r = computeProtocol();
          var h = [];
          h.push('<div class="pp-pr-inner">');
          h.push('<div class="pp-rt-eyebrow">Your protocol</div>');
          h.push('<h1 class="pp-pr-h1">' + r.title + '</h1>');
          h.push('<p class="pp-pr-sub">' + r.sub + '</p>');
          if (r.overlaps.length) {
            h.push('<div class="pp-pr-warn"><div class="pp-pr-warn-t">Heads up — possible overlap</div>' + r.overlaps.map(function (o) { return '<div>' + o + '</div>'; }).join('') + '</div>');
          }
          h.push('<div class="pp-pr-grid"><div class="pp-pr-list">');
          h.push(r.items.map(function (p) {
            var goal = PP_CONCERN_BY_KEY[p.ck] ? PP_CONCERN_BY_KEY[p.ck].name : 'Recommended';
            return '<div class="pp-pr-item"><span class="pp-pr-item-img" data-pp-product="' + p.slug + '"><img src="' + PP_IMG[p.slug] + '" alt="' + p.name.replace(/"/g, '&quot;') + '" loading="lazy"></span>'
              + '<div class="pp-pr-item-body"><div class="pp-pr-item-goal" style="color:' + p.tint + ';">' + goal + '</div>'
              + '<h3 class="pp-pr-item-name" data-pp-product="' + p.slug + '">' + p.name + '</h3>'
              + '<p class="pp-pr-item-hook">' + p.hook + ' · ' + p.active + '</p></div>'
              + '<div class="pp-pr-item-end"><div class="pp-pr-item-price">' + ppMoney(p.price) + '</div><div class="pp-pr-item-sub">' + ppMoney(p.price * 0.85) + ' on plan</div></div></div>';
          }).join(''));
          h.push('</div>');
          h.push('<div class="pp-pr-plan"><div class="pp-pr-plan-e">Your plan</div>');
          h.push('<div class="pp-pr-row pp-pr-row--first"><span>' + r.items.length + ' formulas</span><span>$' + r.monthly + '/mo</span></div>');
          h.push('<div class="pp-pr-row"><span>Cost per day</span><span>$' + r.perDay + '</span></div>');
          h.push('<div class="pp-pr-row pp-pr-row--save"><span>Savings</span><span>−$' + r.savings + '</span></div>');
          h.push('<div class="pp-pr-hr"></div>');
          h.push('<div class="pp-pr-total"><span>Total</span><span>$' + r.total + '</span></div>');
          h.push('<button type="button" class="pp-pr-start" data-pp-protocol-add>Start my protocol</button>');
          h.push('<button type="button" class="pp-pr-retake" data-pp-pr-retake>Retake the finder</button>');
          h.push('</div></div></div>');
          if (pageMounts.proto) { pageMounts.proto.innerHTML = h.join(''); }
        };

        var renderTransp = function () {
          var template = root.querySelector('[data-pp-transparency-template]');
          if (pageMounts.transp && template) {
            pageMounts.transp.replaceChildren(template.content.cloneNode(true));
            if (window.zpInitPages) window.zpInitPages(pageMounts.transp);
          }
        };

        var ingCardsHTML = function () {
          var q = ingState.q.trim().toLowerCase();
          var list = PP_ING.filter(function (i) {
            return !q || i.name.toLowerCase().indexOf(q) > -1 || i.benefit.toLowerCase().indexOf(q) > -1
              || i.cat.toLowerCase().indexOf(q) > -1
              || i.found.some(function (s) { return (PP_BY_SLUG[s] ? PP_BY_SLUG[s].name : s).toLowerCase().indexOf(q) > -1; });
          });
          if (!list.length) {
            return { count: 0, html: '<div class="pp-ing-empty">No ingredients match &ldquo;' + esc(ingState.q.trim()) + '&rdquo;. <button type="button" class="pp-ing-clear" data-pp-ing-clear>Clear the search</button> to see all ' + PP_ING.length + ' ingredients.</div>' };
          }
          /* Per-category accent for the eyebrow + its dot, so the grid is lightly
             colour-coded (blue prostate, indigo sleep/calm/mood, green gut …). */
          var IL_CAT_COLOR = { 'Prostate': '#35708c', 'Sleep & Stress': '#5a54a0', 'Calm & Focus': '#5a54a0', 'Mood': '#5a54a0', 'Gut': '#1f7a54', 'Gut & Metabolic': '#1f7a54', 'Immune': '#c96442', 'Longevity': '#8a4f6a', 'Greens & Energy': '#3f8f63', 'Hair & Skin': '#96662e' };
          return { count: list.length, html: list.map(function (i) {
            var ingImg = i.img || (window.__PP_ING_IMG || {})[i.name] || '';
            /* Real photo when one is uploaded; otherwise a clean text-forward
               card (no grey "add image" placeholder) for a minimal, finished look. */
            var ingVis = ingImg ? '<div class="pp-ing-img"><img src="' + ingImg + '" alt="' + esc(i.name) + '" loading="lazy"></div>' : '';
            return '<div class="pp-ing-card' + (ingImg ? '' : ' pp-ing-card--noimg') + '">' + ingVis + '<div class="pp-ing-body">'
              + '<div class="pp-ing-toprow"><span class="pp-ing-cat" style="color:' + (IL_CAT_COLOR[i.cat] || '#c96442') + '">' + i.cat + '</span><span class="pp-ing-studies">' + i.studies + ' studies</span></div>'
              + '<h3 class="pp-ing-name">' + i.name + '</h3><div class="pp-ing-dose">' + i.dose + '</div>'
              + '<p class="pp-ing-benefit">' + i.benefit + '</p>'
              /* "Found in" is a heading for the chips under it, so it only
                 belongs on the card when there is at least one chip. It used to
                 print unconditionally, which left a bare label with nothing
                 beneath it on every ingredient that is not yet linked to a
                 product. */
              + (function () {
                  /* Prefer the demo-catalog name, then the real product title
                     sent from Liquid; never fall back to a raw handle. An
                     ingredient with no resolvable name contributes no chip. */
                  var chips = (i.found || []).map(function (s, fi) {
                    var label = PP_BY_SLUG[s] ? PP_BY_SLUG[s].name
                      : ((i.foundNames && i.foundNames[fi]) || '');
                    if (!label) { return ''; }
                    return '<span class="pp-ing-chip" data-pp-product="' + esc(s) + '">' + esc(label) + '</span>';
                  }).filter(Boolean);
                  if (!chips.length) { return ''; }
                  return '<div class="pp-ing-foundin">Found in</div><div class="pp-ing-chips">' + chips.join('') + '</div>';
                }())
              + '</div></div>';
          }).join('') };
        };
        /* Count line under the ingredient search. Was referenced but never
           defined, which threw and left the ingredients view (and any page that
           boots straight into it, e.g. /pages/ingredients) blank. */
        var ingCountLabel = function (n) {
          var total = PP_ING.length;
          var searching = ingState.q && ingState.q.trim().length > 0;
          if (searching) {
            return n + ' of ' + total + ' ingredient' + (total === 1 ? '' : 's');
          }
          return total + ' ingredient' + (total === 1 ? '' : 's') + ' in the library';
        };
        var renderIng = function () {
          var cards = ingCardsHTML();
          var h = [];
          h.push('<div class="pp-rt-inner">');
          h.push('<div class="pp-rt-eyebrow">Ingredient library</div>');
          h.push('<h1 class="pp-rt-h1">Look up any ingredient by benefit.</h1>');
          h.push('<p class="pp-rt-sub">Search an active or a goal — sleep, gut, immune — to see the dose we use, what it does, and which formulas contain it.</p>');
          h.push('<input class="pp-rt-input pp-ing-search" data-pp-ing-input value="' + esc(ingState.q) + '" placeholder="Search “saw palmetto”, “sleep”, “immune”…">');
          h.push('<div class="pp-ing-count" data-pp-ing-count>' + ingCountLabel(cards.count) + '</div>');
          h.push('<div class="pp-pdp-cols3 pp-ing-grid" data-pp-ing-grid>' + cards.html + '</div>');
          h.push('</div>');
          if (pageMounts.ing) { pageMounts.ing.innerHTML = h.join(''); }
        };

        var renderBundles = function () {
          var sel = bundlesState.builder;
          var selected = sel.map(function (s) { return PP_BY_SLUG[s]; }).filter(Boolean);
          var sub = selected.reduce(function (a, p) { return a + p.price; }, 0);
          var disc = sel.length >= 3 ? PP_BUNDLE_TIERS.three / 100 : (sel.length >= 2 ? PP_BUNDLE_TIERS.two / 100 : 0);
          var discount = sub * disc;
          var total = sub - discount;
          var overlaps = ppOverlaps(sel);
          var h = [];
          h.push('<div class="pp-rt-inner">');
          h.push('<div class="pp-rt-eyebrow">Bundles &amp; stacks</div>');
          h.push('<h1 class="pp-rt-h1">Build your own stack.</h1>');
          /* There is no 3+ discount. The store's live volume discounts are 5%
             at 6 bottles, 7% at 9 and 9% at 11, so the claim is dropped rather
             than restated at a number that would drift. */
          h.push('<p class="pp-rt-sub" style="max-width:62rem;">Pick the formulas you want, and we’ll flag any overlapping actives so you don’t double up.</p>');
          h.push('<div class="pp-bld-grid">');
          h.push('<div class="pp-bld-tiles">');
          h.push(PP_PRODUCTS.map(function (p) {
            var on = sel.indexOf(p.slug) > -1;
            return '<button type="button" class="pp-bld-tile' + (on ? ' is-on' : '') + '" style="--t:' + p.tint + ';" data-pp-b-toggle="' + p.slug + '">'
              + '<span class="pp-bld-tile-img"><img src="' + PP_IMG[p.slug] + '" alt="' + p.name.replace(/"/g, '&quot;') + '" loading="lazy"></span>'
              + '<span class="pp-bld-tile-name">' + p.name + '</span>'
              + '<span class="pp-bld-tile-price">' + ppMoney(p.price) + '</span>'
              + '<span class="pp-bld-tile-tag">' + (on ? 'In stack' : 'Add') + '</span></button>';
          }).join(''));
          h.push('</div>');
          h.push('<div class="pp-bld-tray"><div class="pp-bld-tray-e">Your stack</div>');
          if (!selected.length) { h.push('<p class="pp-bld-empty">Tap formulas to add them to your stack.</p>'); }
          h.push('<div class="pp-bld-lines">');
          h.push(selected.map(function (p) {
            return '<div class="pp-bld-line"><span class="pp-bld-line-l"><button type="button" class="pp-bld-x" data-pp-b-remove="' + p.slug + '" aria-label="Remove">&times;</button><span><span class="pp-bld-line-n">' + p.name + '</span><span class="pp-bld-line-h">' + p.hook + '</span></span></span><span style="white-space:nowrap;">' + ppMoney(p.price) + '</span></div>';
          }).join(''));
          h.push('</div>');
          if (overlaps.length) {
            h.push('<div class="pp-bld-warn">' + overlaps.map(function (o) { return '<div>' + o + '</div>'; }).join('') + '</div>');
          }
          h.push('<div class="pp-bld-hr"></div>');
          h.push('<div class="pp-bld-row"><span>Subtotal</span><span>' + ppMoney(sub) + '</span></div>');
          h.push('<div class="pp-bld-row pp-bld-row--day"><span>Cost per day</span><span>' + ppMoney(sel.length ? total / 30 : 0) + '</span></div>');
          h.push('<div class="pp-bld-hr"></div>');
          h.push('<div class="pp-bld-total"><span>Total</span><span>' + ppMoney(total) + '</span></div>');
          h.push('<button type="button" class="pp-bld-add" data-pp-bundle-add>Add stack to cart</button>');
          h.push('</div></div>');
          h.push('<h2 class="pp-rt-h2 pp-bld-curated-h">Or start from a curated stack</h2>');
          /* pp-bnd-grid owns the columns here; pp-pdp-cols3 is declared later
             in the stylesheet and would override it back to three. */
          h.push('<div class="pp-bnd-grid">');
          h.push(PP_STACKS_VISIBLE.map(function (b) {
            var bt = ppStackTotals(b.slugs);
            /* One composed photo per stack (the trio shot), from window.__PP_STACK_IMG. */
            var stackImg = (window.__PP_STACK_IMG || {})[b.key] || '';
            var shot = stackImg ? '<img src="' + stackImg + '" alt="' + ppAlt(b.name) + ' bundle" loading="lazy">' : '';
            return '<div class="pp-bnd-card" data-pp-stack-open="' + b.key + '">'
              + '<div class="pp-bnd-shot"><span class="pp-bnd-count">' + b.slugs.length + ' formulas</span>' + shot + '</div>'
              + '<div class="pp-bnd-body">'
              + '<div class="pp-bnd-eyebrow">' + esc(b.eyebrow) + '</div>'
              + '<h3 class="pp-bnd-name">' + esc(b.name) + '</h3>'
              + '<p class="pp-bnd-items">' + esc(b.tagline) + '</p>'
              + '<div class="pp-bnd-prices"><span class="pp-bnd-now">' + ppMoney(bt.now) + '</span>'
              + '<span class="pp-bnd-was">' + ppMoney(bt.was) + '</span>'
              + '<span class="pp-bnd-save">Save ' + ppMoney(bt.save) + '</span></div>'
              + '</div></div>';
          }).join(''));
          h.push('</div></div>');
          if (pageMounts.bundles) { pageMounts.bundles.innerHTML = h.join(''); }
        };

        var renderAbout = function () {
          var h = [];
          h.push('<div class="pp-rt-page" style="padding-top:0;">');
          h.push('<div class="pp-about-hero-wrap"><div class="pp-about-hero"><img src="' + PP_IMG['_about'] + '" alt="Precise Protocols — inside the lab"><div class="pp-about-scrim"></div><div class="pp-about-hero-content">');
          h.push('<div class="pp-rt-eyebrow">About Precise Protocols</div>');
          h.push('<h1 class="pp-about-h1">Supplements should read like a lab report, not a billboard.</h1>');
          h.push('<p class="pp-about-hero-p">We started Precise Protocols because the supplement aisle is built on proprietary blends, vague “support” claims, and doses too small to matter. We do the opposite: one clear job per bottle, every active printed at its clinically-studied amount, and a certificate of analysis for every lot we ship.</p>');
          h.push('</div></div></div>');
          h.push('<div class="pp-rt-pad"><div class="pp-rt-wrap pp-about-vals"><div class="pp-pdp-cols3">');
          h.push([
            ['#3c4f61','Clinically dosed','Every active is included at the amount used in published research — not a pixie-dust sprinkle to justify a label claim. No proprietary blends, ever.'],
            ['#1c7a54','Tested every lot','An independent lab verifies potency, heavy metals, and microbials on every batch. We publish the results — look up any bottle by its lot number.'],
            ['#6b4632','Manufactured in USA','Manufactured in a cGMP-registered facility, gluten-free, non-GMO, and vegan. Backed by a 90-day money-back guarantee — even if the bottle is empty.']
          ].map(function (v) { return '<div class="pp-about-val" style="--vt:' + v[0] + ';"><h3>' + v[1] + '</h3><p>' + v[2] + '</p></div>'; }).join(''));
          h.push('</div></div></div>');
          h.push('<div class="pp-rt-pad"><div class="pp-rt-wrap"><div class="pp-about-std">');
          h.push('<div><div class="pp-about-std-e">Our standard</div><h2 class="pp-about-std-h">Built by people who read the studies.</h2><p class="pp-about-std-p">Our formulas are developed with a scientific advisory team of pharmacists and nutrition researchers, then reformulated whenever the evidence moves. If a dose isn’t supported, it doesn’t go in the bottle.</p></div>');
          h.push('<div class="pp-about-stats">' + [
            [String(PP_PRODUCTS.length), 'Single-purpose formulas &amp; growing'],
            ['100%', 'Lots with published COAs'],
            ['2,400+', 'Verified customers'],
            ['90-day', 'Money-back guarantee']
          ].map(function (s) { return '<div><div class="pp-about-stat-n">' + s[0] + '</div><div class="pp-about-stat-l">' + s[1] + '</div></div>'; }).join('') + '</div>');
          h.push('</div></div></div>');
          h.push('<div class="pp-rt-pad"><div class="pp-rt-wrap"><div class="pp-about-founder">');
          h.push('<div class="pp-about-portrait"><img src="' + PP_IMG['_about'] + '" alt="Precise Protocols formulator" loading="lazy"></div>');
          h.push('<div><div class="pp-rt-eyebrow">From the founder</div><h2 class="pp-about-quote">“I got tired of not being able to trust the label.”</h2>');
          h.push('<p>At 48, after a routine physical, I started reading the labels on my own shelf — and couldn’t tell how much of anything I was actually taking. “Proprietary blend” meant they wouldn’t say. So we built the company I wanted to buy from: every dose printed, every lot tested, every certificate public.</p>');
          h.push('<p>We’re a small team of formulators, a pharmacist, and a nutrition researcher — and we take the same protocols we sell.</p>');
          h.push('<div class="pp-about-sig"><div class="pp-about-sig-av"></div><div><div class="pp-about-sig-n">Daniel Rourke</div><div class="pp-about-sig-t">Founder · Precise Protocols</div></div></div>');
          h.push('</div></div></div></div>');
          h.push('<div class="pp-rt-pad"><div class="pp-rt-wrap"><div class="pp-about-member">');
          h.push('<div class="pp-about-member-head"><div class="pp-about-member-e">The Protocol Membership</div><h2 class="pp-about-member-h">Subscribe and it stops being a purchase. It becomes a protocol.</h2><p class="pp-about-member-p">Every subscription is a membership — no fee, cancel or skip anytime. You just get treated like someone we want to keep.</p></div>');
          h.push('<div class="pp-rt-cols4 pp-about-perks">' + [
            ['Save 15%','On every bottle, always','Locked-in member pricing on everything you take — no promo codes to chase.'],
            ['Free shipping','On every order, no minimum','Members skip the $75 threshold entirely — it ships free from bottle one.'],
            ['Your COAs','Pushed to you each refill','The certificate for your exact lot arrives with every shipment — nothing to look up.'],
            ['Flex control','Skip, swap, or pause anytime','Reschedule a shipment or change formulas in two taps. Never locked in.']
          ].map(function (p) { return '<div class="pp-about-perk"><div class="pp-about-perk-n">' + p[0] + '</div><div class="pp-about-perk-t">' + p[1] + '</div><p class="pp-about-perk-p">' + p[2] + '</p></div>'; }).join('') + '</div>');
          h.push('<div class="pp-about-member-cta"><a class="pp-rt-btn-accent" href="#pp-concerns" data-pp-route="finder">Build my protocol →</a><span class="pp-about-member-note">No membership fee · cancel anytime · 90-day guarantee</span></div>');
          h.push('</div></div></div>');
          h.push('<div class="pp-about-contact"><div class="pp-about-contact-grid">');
          h.push('<div><div class="pp-rt-eyebrow">Contact us</div><h2 class="pp-about-contact-h">Talk to a real person.</h2><p class="pp-about-contact-p">Questions about a formula, your protocol, or an order? Our support team is US-based and replies within one business day.</p>');
          h.push('<div class="pp-about-contact-list">' + [
            ['Email','info@zenmenhealth.com']
          ].map(function (c) { return '<div><div class="pp-about-cl">' + c[0] + '</div><div class="pp-about-cv">' + c[1] + '</div></div>'; }).join('') + '</div></div>');
          var contactTemplate = root.querySelector('[data-pp-contact-template]');
          if (contactTemplate) h.push(contactTemplate.innerHTML);
          h.push('</div></div>');
          h.push('</div>');
          if (pageMounts.about) { pageMounts.about.innerHTML = h.join(''); }
        };

        /* --- Stack detail view --- */
        /* Default to the first stack on offer, but resolve a key against ALL of
           them: #pp-stack/foundation is a real link from the Starter Kit even
           though Foundation is not in the bundles grid. */
        var stackViewKey = PP_STACKS_VISIBLE.length ? PP_STACKS_VISIBLE[0].key : '';
        var stackByKey = function (key) {
          for (var i = 0; i < PP_STACKS.length; i++) { if (PP_STACKS[i].key === key) return PP_STACKS[i]; }
          return PP_STACKS_VISIBLE[0] || PP_STACKS[0];
        };
        var renderStackView = function () {
          var mount = pageMounts.stack;
          if (!mount) { return; }
          var st = stackByKey(stackViewKey);
          var members = st.slugs.map(function (slug) {
            for (var i = 0; i < PP_PRODUCTS.length; i++) { if (PP_PRODUCTS[i].slug === slug) return PP_PRODUCTS[i]; }
            return null;
          }).filter(Boolean);

          /* Averaged from the members on show, not typed, so the headline can
             never claim more than the formulas behind it. */
          var rSum = 0, rN = 0, cSum = 0;
          members.forEach(function (m) {
            if (m.rating) { rSum += Number(m.rating); rN++; }
            cSum += Number(m.count || 0);
          });
          var rAvg = rN ? (rSum / rN).toFixed(1) : '0.0';
          var stars = '';
          for (var s = 1; s <= 5; s++) { stars += s <= Math.round(Number(rAvg)) ? '&#9733;' : '<span class="pp-star-off">&#9733;</span>'; }

          var h = [];
          h.push('<div class="pp-rt-inner pp-rt-pad">');
          h.push('<div class="pp-pdp-crumb"><a href="/" data-pp-page-close>Home</a> &nbsp;/&nbsp; <a href="#pp-bundles" data-pp-route="bundles">Stacks</a> &nbsp;/&nbsp; ' + esc(st.name) + '</div>');

          h.push('<div class="pp-sk-head">');
          h.push('<div class="pp-sk-shot" role="img" aria-label="' + esc(st.ph) + '"></div>');
          h.push('<div class="pp-sk-intro">');
          h.push('<div class="pp-rt-eyebrow">' + esc(st.eyebrow) + '</div>');
          h.push('<h1 class="pp-rt-h1">' + esc(st.name) + '</h1>');
          h.push('<p class="pp-sk-tagline">' + esc(st.tagline) + '</p>');
          if (cSum > 0) h.push('<div class="pp-card-rate"><span class="pp-stars pp-stars--sm">' + stars + '</span>'
            + '<span class="pp-card-rate-n">' + rAvg + '</span>'
            + '<span class="pp-card-rate-c">· ' + cSum.toLocaleString() + ' reviews · ' + st.slugs.length + ' formulas</span></div>');
          h.push('<p class="pp-sk-who">' + esc(st.who) + '</p>');
          h.push('<div class="pp-sk-buy">');
          var skT = ppStackTotals(st.slugs);
          h.push('<div class="pp-stack-prices"><span class="pp-stack-now">' + ppMoney(skT.now) + '</span>'
            + '<span class="pp-stack-was">' + ppMoney(skT.was) + '</span><span class="pp-stack-save">Save ' + ppMoney(skT.save) + '</span></div>');
          h.push('<div class="pp-sk-perday">' + ppMoney(skT.now / 30) + ' a day · subscription price, skip or cancel anytime</div>');
          h.push('<button type="button" class="pp-btn pp-btn--accent pp-btn--block" data-pp-stack-buy>Add stack to cart</button>');
          h.push('<div class="pp-sk-fine">Free U.S. shipping · 90-day money-back guarantee</div>');
          h.push('</div></div></div>');

          h.push('<h2 class="pp-rt-h2">What each formula does here</h2>');
          h.push('<p class="pp-sk-sub">Every bottle in this stack has one job. Nothing is in here twice.</p>');
          h.push('<div class="pp-sk-members">');
          h.push(members.map(function (m) {
            return '<div class="pp-sk-member" style="--t:' + m.tint + ';">'
              + '<span class="pp-sk-member-img"><img src="' + PP_IMG[m.slug] + '" alt="' + ppAlt(m.name) + '" loading="lazy"></span>'
              + '<div class="pp-sk-member-copy"><div class="pp-sk-member-l">' + m.line + '</div>'
              + '<div class="pp-sk-member-n">' + m.name + '</div>'
              + '<p class="pp-sk-member-h">' + m.hook + '</p>'
              + '<div class="pp-sk-member-a">' + m.active + '</div></div>'
              + '<div class="pp-sk-member-buy"><div class="pp-sk-member-p">' + ppMoney(m.price) + '</div>'
              + '<a href="#pp-product/' + m.slug + '" data-pp-product="' + m.slug + '">See formula &rarr;</a></div>'
              + '</div>';
          }).join(''));
          h.push('</div>');

          h.push('<div class="pp-sk-split">');
          h.push('<div><h2 class="pp-rt-h2">How to take it</h2>');
          h.push('<p class="pp-sk-sub">One routine, twice a day. Printed on the bottles too.</p>');
          h.push('<div class="pp-sk-dose"><div><div class="pp-sk-dose-l">Morning</div><div class="pp-sk-dose-v">' + esc(st.am) + '</div></div>');
          h.push('<div><div class="pp-sk-dose-l">Evening</div><div class="pp-sk-dose-v">' + esc(st.pm) + '</div></div></div>');
          h.push('<div class="pp-sk-note">Take with food. These build with consistent daily use.*</div></div>');
          h.push('<div><h2 class="pp-rt-h2">When this isn&rsquo;t the one</h2>');
          h.push('<p class="pp-sk-sub">We would rather point you elsewhere than sell you the wrong stack.</p>');
          h.push('<div class="pp-sk-notfor">' + (st.notFor || []).map(function (n) {
            return '<div><span aria-hidden="true">&ndash;</span><span>' + esc(n) + '</span></div>';
          }).join('') + '</div>');
          h.push('<a class="pp-sk-link" href="#pp-bundles" data-pp-route="bundles">Build your own stack instead &rarr;</a></div>');
          h.push('</div>');

          h.push('<h2 class="pp-rt-h2">What customers say</h2>');
          h.push('<div class="pp-reviews-grid">');
          h.push(PP_STACK_REVIEWS.map(function (r) {
            return '<div class="pp-review"><span class="pp-stars" role="img" aria-label="Rated 5 out of 5">&#9733;&#9733;&#9733;&#9733;&#9733;</span>'
              + '<h3 class="pp-review-t">' + r.t + '</h3><p class="pp-review-b">' + r.b + '</p>'
              + '<div class="pp-review-n">' + r.n + ' · ' + r.tag + '</div></div>';
          }).join(''));
          h.push('</div>');

          h.push('<h2 class="pp-rt-h2">Common questions</h2>');
          h.push('<div class="pp-faq-grid">');
          h.push([
            { q: 'How is a stack different from buying the bottles separately?', a: 'Same formulas, same doses — bundled at a ' + ppMoney(ppStackTotals(st.slugs).save) + ' saving and shipped together so the routine stays simple.' },
            { q: 'How long before I judge it?', a: 'Give it 4–8 weeks of consistent daily use. These work gradually, not overnight.*' },
            { q: 'Can I swap a formula out?', a: 'Yes — Build your own stack lets you assemble any combination, and flags overlapping actives so you don’t double up.' },
            { q: 'Is every lot third-party tested?', a: 'Yes. Each lot is tested by an independent lab for potency, heavy metals and microbials — searchable on the Transparency page.' }
          ].map(function (f) {
            return '<div class="pp-faq-item"><div class="pp-faq-q">' + f.q + '</div><p class="pp-faq-a">' + f.a + '</p></div>';
          }).join(''));
          h.push('</div>');

          h.push('<div class="pp-sk-otherhead"><h2 class="pp-rt-h2">Other stacks</h2>'
            + '<a class="pp-sk-link" href="#pp-bundles" data-pp-route="bundles">All stacks &rarr;</a></div>');
          h.push('<div class="pp-sk-other">');
          h.push(PP_STACKS_VISIBLE.filter(function (o) { return o.key !== st.key; }).map(function (o) {
            var ot = ppStackTotals(o.slugs);
            return '<a class="pp-sk-othercard" href="#pp-stack/' + o.key + '" data-pp-stack-open="' + o.key + '">'
              + '<span class="pp-sk-othershot" aria-hidden="true"></span>'
              + '<span class="pp-sk-othere">' + esc(o.eyebrow) + '</span>'
              + '<span class="pp-sk-othern">' + esc(o.name) + '</span>'
              + '<span class="pp-sk-otherp">' + ppMoney(ot.now) + '<s>' + ppMoney(ot.was) + '</s></span></a>';
          }).join(''));
          h.push('</div></div>');
          mount.innerHTML = h.join('');
        };

        /* --- Cart view --- */
        /* The prototype cart. Precise has no products in Shopify yet and Add
           still toasts "coming soon", so in practice this renders the empty
           state. It is wired properly so it works the day Add becomes real.
           The chrome's cart link is deliberately NOT pointed here: that goes to
           Shopify's own /cart, which holds the customer's actual order. */
        var renderCartView = function () { window.location.assign(window.zpCartRoute('cart')); };

        var PAGE_CLASS = { transp: 'is-transp-open', ing: 'is-ing-open', bundles: 'is-bundles-open', about: 'is-about-open', quiz: 'is-quiz-open', proto: 'is-proto-open', stack: 'is-stack-open', cart: 'is-cart-open' };
        var PAGE_HASH = { transp: '#pp-transparency-page', ing: '#pp-ingredients', bundles: '#pp-bundles', about: '#pp-about', quiz: '#pp-finder', proto: '#pp-protocol', stack: '#pp-stack', cart: '#pp-cart' };
        var PAGE_RENDER = { transp: renderTransp, ing: renderIng, bundles: renderBundles, about: renderAbout, quiz: renderQuiz, proto: renderProto, stack: renderStackView, cart: renderCartView };
        var PP_ROUTE_MAP = { transparency: 'transp', ingredients: 'ing', bundles: 'bundles', about: 'about', finder: 'quiz', protocol: 'proto', cart: 'cart' };
        var clearPageClasses = function () {
          for (var k in PAGE_CLASS) { if (PAGE_CLASS.hasOwnProperty(k)) { root.classList.remove(PAGE_CLASS[k]); } }
        };
        var atHome = function () { return !pdpState.slug && !shopState.open && !pageState.view; };
        var showPage = function (name) {
          if (name === 'cart') { window.location.assign(window.zpCartRoute('cart')); return; }
          if (!PAGE_RENDER[name] || !pageMounts[name]) { return; }
          if (atHome()) { savedScroll = window.pageYOffset || document.documentElement.scrollTop || 0; }
          pdpState.slug = null;
          shopState.open = false;
          root.classList.remove('is-pdp-open');
          root.classList.remove('is-shop-open');
          pageState.view = name;
          PAGE_RENDER[name]();
          clearPageClasses();
          root.classList.add(PAGE_CLASS[name]);
          window.scrollTo(0, 0);
          updateResume();
        };
        var hidePage = function () {
          if (!pageState.view) { return; }
          pageState.view = null;
          clearPageClasses();
          window.scrollTo(0, savedScroll);
          updateResume();
        };
        var openPage = function (name) {
          showPage(name);
          var p = routeFor(name);
          if (p) { histPush({ ppView: name }, p); }
          else { histPush({ ppPage: name }, PAGE_HASH[name]); }
        };
        var closePage = function () {
          hidePage();
          try {
            if (history.state && (history.state.ppPage || history.state.ppView)) { history.back(); return; }
          } catch (err) {}
          goHomeUrl();
        };
        var doLot = function () {
          var q = (transpState.query || '').trim();
          if (!q) { return; }
          transpState.scanning = true;
          transpState.notFound = '';
          renderTransp();
          if (lotTimer) { clearTimeout(lotTimer); }
          lotTimer = setTimeout(function () {
            var entry = ppFindLot(q);
            transpState.scanning = false;
            if (entry) {
              transpState.entry = entry;
              transpState.verified = true;
              transpState.notFound = '';
            } else {
              transpState.verified = false;
              transpState.notFound = q;
            }
            if (pageState.view === 'transp') { renderTransp(); }
          }, 1100);
        };

        var showPdp = function (slug) {
          var p = PP_BY_SLUG[slug];
          if (!p) { return; }
          if (p.url) { window.location.assign(p.url); return; }
          if (atHome()) { savedScroll = window.pageYOffset || document.documentElement.scrollTop || 0; }
          if (pdpState.slug !== slug) { pdpState.sub = !!p.sellingPlanId; pdpState.qty = 1; pdpState.ing = 0; }
          pdpState.slug = slug;
          shopState.open = false;
          pageState.view = null;
          clearPageClasses();
          root.classList.remove('is-shop-open');
          renderPdp(p);
          root.classList.add('is-pdp-open');
          window.scrollTo(0, 0);
        };
        var hidePdp = function () {
          if (!pdpState.slug) { return; }
          pdpState.slug = null;
          root.classList.remove('is-pdp-open');
          window.scrollTo(0, savedScroll);
        };
        var openPdp = function (slug) {
          showPdp(slug);
          histPush({ ppPdp: slug }, '#pp-product/' + slug);
        };
        var closePdp = function () {
          hidePdp();
          try {
            if (history.state && history.state.ppPdp) { history.back(); return; }
          } catch (err) {}
          goHomeUrl();
        };
        /* --- Arriving from a curated stack --- */
        /* A stack card carries its contents in the URL, as "#pp-bundles/a,b,c"
           or "?stack=a,b,c" on the real bundles page, so the builder opens with
           that stack already in the tray and the link stays shareable.
           Unknown slugs are dropped rather than quietly mis-sizing a stack. */
        var STACK_HASH_RE = /^#pp-bundles\/([a-z0-9,-]+)$/;
        var parseStackSlugs = function (raw) {
          var out = [];
          if (!raw) { return out; }
          String(raw).split(',').forEach(function (s) {
            var slug = s.trim();
            if (slug && PP_BY_SLUG[slug] && out.indexOf(slug) < 0) { out.push(slug); }
          });
          return out;
        };
        var stackFromUrl = function () {
          var m = (window.location.hash || '').match(STACK_HASH_RE);
          if (m) { return parseStackSlugs(m[1]); }
          var q = (window.location.search || '').match(/[?&]stack=([^&]*)/);
          if (!q) { return []; }
          var raw = q[1];
          try { raw = decodeURIComponent(raw); } catch (err) {}
          return parseStackSlugs(raw);
        };
        var openBundlesWithStack = function (slugs) {
          /* Only replace the tray when the URL actually named a stack, so a
             plain visit to the bundles page keeps whatever was being built. */
          if (slugs && slugs.length) { bundlesState.builder = slugs; }
          showPage('bundles');
        };

        /* Route resolution for both URL styles: hash first (legacy + pdp/proto), then real paths */
        var checkRoute = function () {
          var hash = window.location.hash || '';
          var mp = hash.match(/^#pp-product\/([a-z0-9-]+)$/);
          var ms = hash.match(/^#pp-shop(?:\/([a-z]+))?$/);
          var pg = null;
          for (var k in PAGE_HASH) { if (PAGE_HASH.hasOwnProperty(k) && PAGE_HASH[k] === hash) { pg = k; } }
          var pv = viewForPath(window.location.pathname);
          var mb = hash.match(STACK_HASH_RE);
          /* #pp-stack/<key> opens the detail view for that stack. Checked
             before the bundles hash so it is not read as a slug list. */
          var mk = hash.match(/^#pp-stack\/([a-z0-9-]+)$/);
          if (mp && PP_BY_SLUG[mp[1]]) { showPdp(mp[1]); }
          else if (mk) { stackViewKey = mk[1]; showPage('stack'); }
          else if (ms) { showShop(ms[1] || 'All'); }
          else if (mb) { openBundlesWithStack(parseStackSlugs(mb[1])); }
          else if (pg) { showPage(pg); }
          else if (pv === 'shop') { showShop(concernFromSearch() || 'All'); }
          else if (pv === 'bundles') { openBundlesWithStack(stackFromUrl()); }
          else if (pv) { showPage(pv); }
          else { hidePdp(); hideShop(); hidePage(); }
        };

        /* Auto-tag prototype product links by their visible name, so a click
           opens the client-side PDP. Links already pointing at a real Shopify
           product URL are skipped: a merchant-picked collection has to navigate
           for real, even when a product shares a name with the prototype list. */
        Array.prototype.forEach.call(root.querySelectorAll('.pp-strip-item, .pp-card, .pp-panel-prod, .pp-mega-item'), function (a) {
          if ((a.getAttribute('href') || '').indexOf('#pp-product/') < 0) { return; }
          var nameEl = a.querySelector('.pp-strip-name, .pp-card-name, .pp-panel-name, .pp-mega-item-name');
          if (!nameEl) { return; }
          var slug = PP_BY_NAME[nameEl.textContent.trim()];
          if (slug) { a.setAttribute('data-pp-product', slug); }
        });

        /* Delegated clicks: open PDP, close/goto, plan/qty/carousel/add */
        root.addEventListener('click', function (e) {
          var find = function (sel) { return e.target.closest ? e.target.closest(sel) : null; };
          function addProducts(slugs, button) {
            var products = slugs.map(function (slug) { return PP_BY_SLUG[slug]; });
            if (!products.length || products.some(function (p) { return !p || !p.variantId || !p.available; })) { window.zpCommerceError(button, 'Some products in this stack are unavailable. Update your selection.'); return; }
            if (products.some(function (p) { return p.requiresPlan; })) { window.zpCommerceError(button, 'This selection contains a subscription-only product. Choose its delivery plan on the product page.'); return; }
            window.zpAddItems(products.map(function (p) { var item = { id: p.variantId, quantity: 1 }; if (p.requiresPlan) item.selling_plan = p.sellingPlanId; return item; }), button);
          }
          var bundleAdd = find('[data-pp-bundle-add]');
          if (bundleAdd) { e.preventDefault(); addProducts(bundlesState.builder, bundleAdd); return; }
          var protocolAdd = find('[data-pp-protocol-add]');
          if (protocolAdd) { e.preventDefault(); addProducts(computeProtocol().items.map(function (p) { return p.slug; }), protocolAdd); return; }
          var stackBuy = find('[data-pp-stack-buy]');
          if (stackBuy) { e.preventDefault(); addProducts(stackByKey(stackViewKey).slugs, stackBuy); return; }
          var kitBuy = find('[data-pp-kit-add]');
          if (kitBuy) { e.preventDefault(); if (PP_KIT_STACK) addProducts(PP_KIT_STACK.slugs, kitBuy); return; }

          /* The Add pill is a prototype affordance that toasts "coming soon".
             On a real product card it reads View and the click has to fall
             through to the card's own link, or the product page is unreachable. */
          /* Supply tier and plan pills re-render the shop grid in place. Read
             before the Add pill, which would otherwise swallow the click. */
          var tierBtn = find('[data-pp-tier]');
          if (tierBtn) {
            e.preventDefault();
            var tParts = tierBtn.getAttribute('data-pp-tier').split('|');
            buyState.tier[tParts[0]] = parseInt(tParts[1], 10) || 1;
            renderShop();
            return;
          }
          var modeBtn = find('[data-pp-mode]');
          if (modeBtn) {
            e.preventDefault();
            var mParts = modeBtn.getAttribute('data-pp-mode').split('|');
            buyState.mode[mParts[0]] = mParts[1];
            renderShop();
            return;
          }
          /* Real add-to-cart + open the side drawer for the shop card buy button. */
          var buyBtn = find('.pp-card-add--buy');
          if (buyBtn && window.zpAddToCart) {
            e.preventDefault();
            var buyCard = buyBtn.closest('[data-pp-card]');
            var buySlug = buyCard && buyCard.getAttribute('data-pp-card');
            var buyP = buySlug && PP_BY_SLUG[buySlug];
            if (buyP && buyP.variantId) {
              var buyOnce = buyState.mode[buySlug] === 'once';
              var buyPlan = (!buyOnce && buyP.sellingPlanId) ? buyP.sellingPlanId : null;
              window.zpAddToCart(buyP.variantId, buyState.tier[buySlug] || 1, buyPlan, buyBtn);
            } else { toast(); }
            return;
          }
          /* PDP add-to-cart + open the side drawer. */
          var pdpAddBtn = find('[data-pdp-add]');
          if (pdpAddBtn && window.zpAddToCart) {
            e.preventDefault();
            var pdpP = PP_BY_SLUG[pdpState.slug];
            if (pdpP && pdpP.variantId) {
              var pdpPlan = (pdpState.sub && pdpP.sellingPlanId) ? pdpP.sellingPlanId : null;
              window.zpAddToCart(pdpP.variantId, pdpState.qty, pdpPlan, pdpAddBtn);
            } else { toast(); }
            return;
          }
          var addPill = find('.pp-card-add');
          if (addPill) {
            /* The Add pill is a prototype affordance that toasts "coming soon".
               On a real product card it reads View and the click has to fall
               through to the card's own link, or the product page is
               unreachable. The prototype card is a div with no link at all, so
               anything not sitting inside a real product anchor toasts. */
            var pillLink = addPill.closest('a');
            var pillHref = pillLink ? (pillLink.getAttribute('href') || '') : '';
            if (!pillLink || pillHref.indexOf('#pp-product/') > -1) {
              e.preventDefault(); toast(); return;
            }
          } else if (find('[data-pp-toast]')) { e.preventDefault(); toast(); return; }
          var prod = find('[data-pp-product]');
          if (prod && root.contains(prod)) { e.preventDefault(); openPdp(prod.getAttribute('data-pp-product')); return; }
          if (find('[data-pdp-close]')) { e.preventDefault(); closePdp(); return; }
          if (find('[data-pp-shop-close]')) { e.preventDefault(); closeShop(); return; }
          var shopOpenLink = find('[data-pp-shop-open]');
          if (shopOpenLink) { e.preventDefault(); openShop(shopOpenLink.getAttribute('data-pp-shop-open')); return; }
          /* Finder banner goal cards toggle in place (up to GOAL_CAP) rather
             than jumping straight into the quiz, so "Pick up to 3" is real.
             Route links that also carry a goal keep the old preselect path. */
          var goalToggle = find('[data-pp-q-goal]');
          if (goalToggle && !goalToggle.hasAttribute('data-pp-route')) {
            e.preventDefault();
            toggleGoal(goalToggle.getAttribute('data-pp-q-goal'));
            return;
          }
          var routeLink = find('[data-pp-route]');
          if (routeLink) {
            e.preventDefault();
            var preGoal = routeLink.getAttribute('data-pp-q-goal');
            if (preGoal && PP_CONCERN_BY_KEY[preGoal]) {
              finderState.goals = [preGoal];
              finderState.step = 0;
              saveFinder();
            }
            openPage(PP_ROUTE_MAP[routeLink.getAttribute('data-pp-route')]);
            return;
          }
          /* finder quiz interactions */
          var qEl;
          if ((qEl = find('[data-pp-qg]'))) {
            var gKey = qEl.getAttribute('data-pp-qg');
            if (finderState.goals.indexOf(gKey) > -1) {
              finderState.goals = finderState.goals.filter(function (x) { return x !== gKey; });
            } else if (finderState.goals.length < 3) {
              finderState.goals = finderState.goals.concat([gKey]);
            }
            saveFinder(); renderQuiz(); return;
          }
          if ((qEl = find('[data-pp-qs]'))) {
            var sLbl = PP_QF_SYMPTOMS[parseInt(qEl.getAttribute('data-pp-qs'), 10)].label;
            finderState.symptoms = finderState.symptoms.indexOf(sLbl) > -1
              ? finderState.symptoms.filter(function (x) { return x !== sLbl; })
              : finderState.symptoms.concat([sLbl]);
            saveFinder(); renderQuiz(); return;
          }
          if ((qEl = find('[data-pp-ql]'))) {
            var lLbl = PP_QF_LIFESTYLE[parseInt(qEl.getAttribute('data-pp-ql'), 10)].label;
            finderState.lifestyle = finderState.lifestyle.indexOf(lLbl) > -1
              ? finderState.lifestyle.filter(function (x) { return x !== lLbl; })
              : finderState.lifestyle.concat([lLbl]);
            saveFinder(); renderQuiz(); return;
          }
          if ((qEl = find('[data-pp-qp]'))) {
            var pLbl = PP_QF_PRIORITIES[parseInt(qEl.getAttribute('data-pp-qp'), 10)];
            finderState.priorities = finderState.priorities.indexOf(pLbl) > -1
              ? finderState.priorities.filter(function (x) { return x !== pLbl; })
              : finderState.priorities.concat([pLbl]);
            saveFinder(); renderQuiz(); return;
          }
          if ((qEl = find('[data-pp-qt]'))) {
            var tLbl = PP_QF_TAKING[parseInt(qEl.getAttribute('data-pp-qt'), 10)];
            finderState.taking = finderState.taking.indexOf(tLbl) > -1
              ? finderState.taking.filter(function (x) { return x !== tLbl; })
              : finderState.taking.concat([tLbl]);
            saveFinder(); renderQuiz(); return;
          }
          if ((qEl = find('[data-pp-qa]'))) { finderState.age = PP_QF_AGES[parseInt(qEl.getAttribute('data-pp-qa'), 10)]; saveFinder(); renderQuiz(); return; }
          if ((qEl = find('[data-pp-qf]'))) { finderState.format = qEl.getAttribute('data-pp-qf'); saveFinder(); renderQuiz(); return; }
          if ((qEl = find('[data-pp-qb]'))) { finderState.budget = qEl.getAttribute('data-pp-qb'); saveFinder(); renderQuiz(); return; }
          if ((qEl = find('[data-pp-qr]'))) { finderState.readiness = qEl.getAttribute('data-pp-qr'); saveFinder(); renderQuiz(); return; }
          if ((qEl = find('[data-pp-qc]'))) { finderState.cadence = qEl.getAttribute('data-pp-qc'); saveFinder(); renderQuiz(); return; }
          if (find('[data-pp-q-next]')) {
            if (finderState.step < 9) { finderState.step += 1; saveFinder(); renderQuiz(); window.scrollTo(0, 0); }
            else { openPage('proto'); }
            return;
          }
          if (find('[data-pp-q-back]')) {
            if (finderState.step > 0) { finderState.step -= 1; saveFinder(); renderQuiz(); window.scrollTo(0, 0); }
            else { closePage(); }
            return;
          }
          /* A stack card opens the detail view and keeps the key in the URL,
             so the link stays shareable and Back returns where it came from. */
          var stackOpen = find('[data-pp-stack-open]');
          if (stackOpen) {
            e.preventDefault();
            stackViewKey = stackOpen.getAttribute('data-pp-stack-open');
            showPage('stack');
            histPush({ ppPage: 'stack', ppStack: stackViewKey }, '#pp-stack/' + stackViewKey);
            return;
          }
          if (find('[data-pp-page-close]')) { e.preventDefault(); closePage(); return; }
          if (find('[data-pp-pr-retake]')) { openPage('quiz'); return; }
          if (find('[data-pp-resume-go]')) { finderState.resumeDismissed = true; saveFinder(); openPage('quiz'); return; }
          if (find('[data-pp-resume-dismiss]')) { finderState.resumeDismissed = true; saveFinder(); return; }
          var shopTab = find('[data-pp-shop-tab]');
          if (shopTab) {
            shopState.concern = shopTab.getAttribute('data-pp-shop-tab');
            renderShop();
            var su = shopUrl();
            if (su && viewForPath(window.location.pathname) === 'shop') { histReplace({ ppView: 'shop' }, su); }
            else { histReplace({ ppShop: shopState.concern }, shopHash()); }
            return;
          }
          if (find('[data-pp-ing-clear]')) { ingState.q = ''; renderIng(); return; }
          if (find('[data-pp-lot-btn]')) { doLot(); return; }
          var lotRow = find('[data-pp-lot-row]');
          if (lotRow) { transpState.query = lotRow.getAttribute('data-pp-lot-row'); doLot(); return; }
          var bToggle = find('[data-pp-b-toggle]');
          var bRemove = find('[data-pp-b-remove]');
          if (bRemove) {
            bundlesState.builder = bundlesState.builder.filter(function (s) { return s !== bRemove.getAttribute('data-pp-b-remove'); });
            renderBundles(); return;
          }
          if (bToggle) {
            var bSlug = bToggle.getAttribute('data-pp-b-toggle');
            if (bundlesState.builder.indexOf(bSlug) > -1) {
              bundlesState.builder = bundlesState.builder.filter(function (s) { return s !== bSlug; });
            } else {
              bundlesState.builder = bundlesState.builder.concat([bSlug]);
            }
            renderBundles(); return;
          }
          var bFill = find('[data-pp-b-fill]');
          if (bFill) {
            bundlesState.builder = bFill.getAttribute('data-pp-b-fill').split(',');
            renderBundles();
            window.scrollTo(0, 0);
            return;
          }
          if (find('[data-pp-pdp-goto]')) {
            hidePdp(); hideShop(); hidePage();
            goHomeUrl();
            return;
          }
          if ((pdpState.slug || shopState.open || pageState.view) && find('a[href^="#pp-"]') && !pdpSection.contains(e.target) && !shopSection.contains(e.target)) {
            hidePdp(); hideShop(); hidePage();
            goHomeUrl();
            return;
          }
          if (!pdpState.slug) { return; }
          var p = PP_BY_SLUG[pdpState.slug];
          var subBtn = find('[data-pdp-sub]');
          if (subBtn) { pdpState.sub = subBtn.getAttribute('data-pdp-sub') === '1'; renderPdp(p); return; }
          if (find('[data-pdp-dec]')) { pdpState.qty = Math.max(1, pdpState.qty - 1); syncPdpQty(); return; }
          if (find('[data-pdp-inc]')) { pdpState.qty += 1; syncPdpQty(); return; }
          if (find('[data-pdp-add]')) { toast(); return; }
          var n = ppDerive(p).ingredientRows.length;
          var updateCar = function () {
            var track = pdpMount.querySelector('[data-pdp-track]');
            var pos = pdpMount.querySelector('[data-pdp-pos]');
            if (track) { track.style.transform = 'translateX(-' + (pdpState.ing * 100) + '%)'; }
            if (pos) { pos.textContent = (pdpState.ing + 1) + ' / ' + n; }
            Array.prototype.forEach.call(pdpMount.querySelectorAll('[data-pdp-dot]'), function (dEl, i) {
              dEl.classList.toggle('is-on', i === pdpState.ing);
            });
          };
          var dot = find('[data-pdp-dot]');
          if (dot) { pdpState.ing = parseInt(dot.getAttribute('data-pdp-dot'), 10) || 0; updateCar(); return; }
          if (find('[data-pdp-prev]')) { pdpState.ing = (pdpState.ing - 1 + n) % n; updateCar(); return; }
          if (find('[data-pdp-next]')) { pdpState.ing = (pdpState.ing + 1) % n; updateCar(); return; }
        });

        root.addEventListener('input', function (e) {
          var t = e.target;
          if (!t || !t.hasAttribute) { return; }
          if (t.hasAttribute('data-pp-ing-input')) {
            ingState.q = t.value;
            var cards = ingCardsHTML();
            var g = root.querySelector('[data-pp-ing-grid]');
            var c = root.querySelector('[data-pp-ing-count]');
            if (g) { g.innerHTML = cards.html; }
            if (c) { c.textContent = ingCountLabel(cards.count); }
          } else if (t.hasAttribute('data-pp-lot-input')) {
            transpState.query = t.value;
            if (transpState.notFound) { transpState.notFound = ''; }
          } else if (t.hasAttribute('data-pp-q-email')) {
            finderState.email = t.value;
            saveFinder();
          }
        });
        document.addEventListener('keydown', function (e) {
          if (e.key !== 'Escape' && e.key !== 'Esc') { return; }
          if (ppEmailShown && ppEmailShown()) { closeEmail(); return; }
          if (pdpState.slug) { closePdp(); }
          else if (shopState.open) { closeShop(); }
          else if (pageState.view) { closePage(); }
        });
        window.addEventListener('popstate', checkRoute);
        /* Address-bar hash edits and in-page hash links must also route.
           checkRoute() no-ops for non-route hashes (plain anchors keep native scroll). */
        window.addEventListener('hashchange', checkRoute);
        /* True only for hashes that map to an actual view — plain section anchors
           like #pp-transparency (the homepage proof band) must NOT hijack boot. */
        var hashResolves = function (hash) {
          if (/^#pp-product\/[a-z0-9-]+$/.test(hash) || /^#pp-shop(?:\/[a-z]+)?$/.test(hash)) { return true; }
          if (STACK_HASH_RE.test(hash)) { return true; }
          for (var k in PAGE_HASH) { if (PAGE_HASH.hasOwnProperty(k) && PAGE_HASH[k] === hash) { return true; } }
          return false;
        };
        /* Boot: resolving hash deep links win; then page-template initial view (URL
           already correct, never rewritten); then path/hash resolution; else home. */
        (function () {
          var IV_MAP = { shop: 'shop', finder: 'quiz', transparency: 'transp', ingredients: 'ing', bundles: 'bundles', about: 'about', protocol: 'proto', cart: 'cart' };
          var iv = window.__PP_INITIAL_VIEW ? IV_MAP[String(window.__PP_INITIAL_VIEW).trim().toLowerCase()] : null;
          var hash = window.location.hash || '';
          if (hash.indexOf('#pp-') === 0 && hashResolves(hash)) { checkRoute(); }
          else if (iv === 'shop') { showShop(concernFromSearch() || 'All'); }
          /* Landing straight on the bundles page template with ?stack= set */
          else if (iv === 'bundles') { openBundlesWithStack(stackFromUrl()); }
          else if (iv) { showPage(iv); }
          else { checkRoute(); }
          root.classList.remove('is-preboot');
        })();
        updateResume();
        /* Reflect goals restored from localStorage on the banner cards. */
        syncBannerGoals();

        /* --- Email capture modal --- */
        var emailModal = root.querySelector('[data-pp-email]');
        if (emailModal) {
          var EMAIL_KEY = 'pp_email_popup_dismissed';
          var emailLastFocus = null;
          var emailShown = function () { return emailModal.classList.contains('is-open'); };
          var emailDismissed = function () {
            try { return window.localStorage.getItem(EMAIL_KEY) === '1'; } catch (err) { return false; }
          };
          var markEmailDone = function () {
            try { window.localStorage.setItem(EMAIL_KEY, '1'); } catch (err) {}
          };
          var openEmail = function () {
            if (emailShown()) { return; }
            emailLastFocus = document.activeElement;
            emailModal.removeAttribute('hidden');
            requestAnimationFrame(function () {
              requestAnimationFrame(function () { emailModal.classList.add('is-open'); });
            });
            setTimeout(function () {
              var success = emailModal.querySelector('[data-pp-email-success]:not([hidden])');
              if (success) {
                var shopBtn = emailModal.querySelector('.pp-email-shop');
                if (shopBtn) { shopBtn.focus(); }
              } else {
                var inp = emailModal.querySelector('input[name="contact[email]"]');
                if (inp) { inp.focus(); }
              }
            }, 80);
          };
          closeEmail = function () {
            markEmailDone();
            emailModal.classList.remove('is-open');
            setTimeout(function () { emailModal.setAttribute('hidden', ''); }, 260);
            if (emailLastFocus && emailLastFocus.focus) { try { emailLastFocus.focus(); } catch (err) {} }
          };
          ppEmailShown = emailShown;
          var showEmailSuccess = function () {
            var formWrap = emailModal.querySelector('[data-pp-email-form-wrap]');
            var successWrap = emailModal.querySelector('[data-pp-email-success]');
            if (formWrap) { formWrap.setAttribute('hidden', ''); }
            if (successWrap) { successWrap.removeAttribute('hidden'); }
            var echo = emailModal.querySelector('[data-pp-email-echo]');
            var addr = '';
            try { addr = window.localStorage.getItem('pp_email_addr') || ''; } catch (err) {}
            if (echo && addr) { echo.textContent = addr; }
          };
          Array.prototype.forEach.call(emailModal.querySelectorAll('[data-pp-email-close]'), function (b) {
            b.addEventListener('click', function () { closeEmail(); });
          });
          var copyBtn = emailModal.querySelector('[data-pp-email-copy]');
          if (copyBtn) {
            copyBtn.addEventListener('click', function () {
              try { navigator.clipboard.writeText('PRECISE15'); copyBtn.textContent = 'Copied'; } catch (err) {}
            });
          }
          var emailForm = emailModal.querySelector('form');
          var emailInput = emailModal.querySelector('input[name="contact[email]"]');
          if (emailForm && emailInput) {
            emailForm.addEventListener('submit', function (ev) {
              var v = (emailInput.value || '').trim();
              if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)) {
                ev.preventDefault();
                emailModal.classList.add('has-error');
                var ce = emailModal.querySelector('[data-pp-email-client-err]');
                if (ce) { ce.removeAttribute('hidden'); }
                emailInput.focus();
                return;
              }
              try { window.localStorage.setItem('pp_email_addr', v); } catch (err) {}
              markEmailDone();
            });
            emailInput.addEventListener('input', function () {
              emailModal.classList.remove('has-error');
              var ce = emailModal.querySelector('[data-pp-email-client-err]');
              if (ce) { ce.setAttribute('hidden', ''); }
            });
          }
          if (window.location.hash === '#pp-email-thanks') {
            markEmailDone();
            showEmailSuccess();
            openEmail();
            histReplace(null, window.location.pathname + window.location.search);
          } else if (emailModal.querySelector('[data-pp-email-errors]')) {
            openEmail(); /* server-side form errors: reopen with inline message */
          } else if (!emailDismissed()) {
            var popupDelay = parseInt(emailModal.getAttribute('data-pp-popup-delay'), 10);
            if (isNaN(popupDelay)) { popupDelay = 6; }
            setTimeout(function () {
              var resumeEl = root.querySelector('[data-pp-resume]');
              var resumeVisible = resumeEl && !resumeEl.hasAttribute('hidden');
              var headerBusy = document.querySelector('details-modal details[open], dialog[open], cart-drawer.active, [data-pp-mobile].is-open, .pp-nav.is-mega-open');
              var privacyBanner = document.getElementById('shopify-pc__banner');
              var privacyVisible = privacyBanner && privacyBanner.getClientRects().length > 0;
              if (!emailDismissed() && !emailShown() && atHome() && !resumeVisible && !headerBusy && !privacyVisible && document.documentElement.getAttribute('data-brand') !== 'zenmen') { openEmail(); }
            }, popupDelay * 1000); /* prototype default: 6s after load */
          }
        }
      }

      /* --- Curated stacks panel (prototype presentation) --- */
      var stacksMount = root.querySelector('[data-pp-stacks-mount]');
      var stacksImg = root.querySelector('[data-pp-stacks-img]');
      if (stacksMount) {
        var stackIdx = 0;
        var stackBySlug = function (slug) {
          for (var i = 0; i < PP_PRODUCTS.length; i++) {
            if (PP_PRODUCTS[i].slug === slug) return PP_PRODUCTS[i];
          }
          return null;
        };
        /* Local copies: the shared esc/ppMoney live in a different closure. */
        var stackEsc = function (s) {
          return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;')
            .replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
        };
        var stackUsd = function (n) { return window.zpMoney(Math.round(Number(n) * 100)); };
        /* Same 3+ bundle tier the builder and the banner copy use. Read from the
           window global rather than the PP_TIERS closure, which this IIFE cannot
           see. Falls back to the schema default. */
        var stackPct = (function () {
          var t = (window.__PP_BUNDLE_TIERS || {}).three;
          var n = parseFloat(t);
          return isNaN(n) ? 15 : n;
        })();
        /* Shopify prices are in cents; the built-in catalog is in dollars. */
        var stackUsdCents = function (c) { return window.zpMoney(c); };
        /* The panel shows the connected pp_stack metaobjects when there are any,
           otherwise the built-in stacks. */
        var PP_LIST = PP_STACKS_PANEL || PP_STACKS_VISIBLE;
        if (stackIdx >= PP_LIST.length) { stackIdx = 0; }
        var renderStacks = function () {
          var cur = PP_LIST[stackIdx];
          var isMeta = !!cur.lines;
          var tabs = PP_LIST.map(function (s, i) {
            return '<button type="button" class="pp-stack-tab' + (i === stackIdx ? ' is-on' : '') + '" data-pp-stack-tab="' + i + '">' + stackEsc(s.name) + '</button>';
          }).join('');
          var linesHtml, nowHtml, wasHtml, saveHtml, insideHref, insideAttr;
          if (isMeta) {
            /* Metaobject stack: products, prices and links resolved server-side,
               so the figures are whatever the stack's products (or its linked
               bundle product / discount) actually come to. */
            linesHtml = cur.lines.map(function (m) {
              return '<a class="pp-stack-line" href="' + (m.url || '#') + '">'
                + '<span><span class="pp-stack-line-n">' + stackEsc(m.name) + '</span>'
                + (m.line ? '<span class="pp-stack-line-l">' + stackEsc(m.line) + '</span>' : '')
                + '</span><span class="pp-stack-line-p">' + stackUsdCents(m.priceCents) + '</span></a>';
            }).join('');
            var metaSave = Number(cur.saveCents) > 0;
            nowHtml = stackUsdCents(cur.nowCents);
            wasHtml = metaSave ? '<span class="pp-stack-was">' + stackUsdCents(cur.wasCents) + '</span>' : '';
            saveHtml = metaSave ? '<span class="pp-stack-save">Save ' + stackUsdCents(cur.saveCents) + '</span>' : '';
            insideHref = cur.insideUrl || '#pp-bundles';
            insideAttr = ' data-pp-route="bundles"';
          } else {
            /* Built-in stack: sum the members and apply the shared bundle tier so
               the total, the strike-through and the saving stay honest. */
            var stackWas = 0;
            linesHtml = cur.slugs.map(function (slug) {
              var p = stackBySlug(slug);
              if (!p) return '';
              stackWas += Number(p.price);
              return '<a class="pp-stack-line" href="#pp-product/' + p.slug + '" data-pp-product="' + p.slug + '">'
                + '<span><span class="pp-stack-line-n">' + p.name + '</span><span class="pp-stack-line-l">' + p.line + '</span></span>'
                + '<span class="pp-stack-line-p">' + stackUsd(p.price) + '</span></a>';
            }).join('');
            var stackNow = stackWas * (1 - (stackPct / 100));
            nowHtml = stackUsd(stackNow);
            wasHtml = '<span class="pp-stack-was">' + stackUsd(stackWas) + '</span>';
            saveHtml = '<span class="pp-stack-save">Save ' + stackUsd(stackWas - stackNow) + '</span>';
            insideHref = '#pp-stack/' + cur.key;
            insideAttr = ' data-pp-stack-open="' + cur.key + '"';
          }
          stacksMount.innerHTML =
            '<div class="pp-stack-tabs">' + tabs + '</div>'
            + (cur.eyebrow ? '<div class="pp-stack-eyebrow">' + stackEsc(cur.eyebrow) + '</div>' : '')
            + '<h3 class="pp-stack-name">' + stackEsc(cur.name) + '</h3>'
            + (cur.who ? '<p class="pp-stack-who">' + stackEsc(cur.who) + '</p>' : '')
            + '<div class="pp-stack-lines">' + linesHtml + '</div>'
            + '<div class="pp-stack-prices"><span class="pp-stack-now">' + nowHtml + '</span>'
            + wasHtml + saveHtml + '</div>'
            + '<div class="pp-stack-actions">'
            + '<button type="button" class="pp-btn pp-btn--accent" data-pp-panel-add>Add stack to cart</button>'
            + '<a class="pp-stack-inside" href="' + insideHref + '"' + insideAttr + '>What&rsquo;s inside</a>'
            + '</div>';
          if (stacksImg) {
            /* A metaobject stack shows its own image; a built-in shows the theme
               editor photo (window.__PP_STACK_IMG, a real CDN URL when uploaded
               or the grey SVG placeholder data-URI when not). No photo => the
               slide keeps the gradient and names what belongs there. */
            var photoSrc, hasPhoto;
            if (isMeta) {
              photoSrc = cur.img || '';
              hasPhoto = !!photoSrc;
            } else {
              var stackRaw = (window.__PP_STACK_IMG || {})[cur.key] || '';
              hasPhoto = stackRaw && stackRaw.indexOf('data:image/svg') === -1;
              photoSrc = hasPhoto ? stackRaw : '';
            }
            var caption = cur.ph || cur.name;
            var dots = PP_LIST.map(function (s, i) {
              return '<button type="button" class="pp-stack-dot' + (i === stackIdx ? ' is-on' : '') + '" data-pp-stack-tab="' + i + '" aria-label="' + stackEsc(s.name) + '"></button>';
            }).join('');
            stacksImg.innerHTML =
              '<div class="pp-stack-slide' + (hasPhoto ? ' pp-stack-slide--photo' : '') + '" role="img" aria-label="' + stackEsc(caption) + '">'
              + (hasPhoto
                ? '<img class="pp-stack-photo" src="' + photoSrc + '" alt="' + stackEsc(cur.name) + '" loading="lazy" decoding="async">'
                : '<span class="pp-stack-ph">' + stackEsc(caption) + '</span>') + '</div>'
              + '<div class="pp-stack-nav"><div class="pp-stack-dots">' + dots + '</div>'
              + '<div class="pp-stack-count"><span>' + (stackIdx + 1) + ' / ' + PP_LIST.length + '</span>'
              + '<button type="button" class="pp-stack-arrow" data-pp-stack-step="-1" aria-label="Previous stack">&larr;</button>'
              + '<button type="button" class="pp-stack-arrow" data-pp-stack-step="1" aria-label="Next stack">&rarr;</button></div></div>';
          }
        };
        renderStacks();
        root.addEventListener('click', function (e) {
          var panelAdd = e.target.closest('[data-pp-panel-add]');
          if (panelAdd) {
            e.preventDefault(); var selectedStack = PP_LIST[stackIdx];
            var members = selectedStack.lines || selectedStack.slugs.map(stackBySlug);
            if (!members.length || members.some(function (p) { return !p || !p.variantId || !p.available; })) { window.zpCommerceError(panelAdd, 'Some products in this stack are unavailable. Choose another stack.'); return; }
            if (members.some(function (p) { return p.requiresPlan; })) { window.zpCommerceError(panelAdd, 'This selection contains a subscription-only product. Choose its delivery plan on the product page.'); return; }
            window.zpAddItems(members.map(function (p) { var item = { id: p.variantId, quantity: 1 }; if (p.requiresPlan) item.selling_plan = p.sellingPlanId; return item; }), panelAdd); return;
          }
          var tab = e.target.closest ? e.target.closest('[data-pp-stack-tab]') : null;
          if (tab) {
            e.preventDefault();
            stackIdx = parseInt(tab.getAttribute('data-pp-stack-tab'), 10) || 0;
            renderStacks();
            return;
          }
          var step = e.target.closest ? e.target.closest('[data-pp-stack-step]') : null;
          if (step) {
            e.preventDefault();
            var d = parseInt(step.getAttribute('data-pp-stack-step'), 10) || 1;
            stackIdx = (stackIdx + d + PP_LIST.length) % PP_LIST.length;
            renderStacks();
          }
        });
      }

      /* --- Foundation starter kit pricing --- */
      /* Derived, never typed: the kit is the first curated bundle, charged at
         the subscriber rate, and the was-price is list plus the extras value.
         If the bundle or its products ever change, the band follows. */
      var kitEl = root.querySelector('[data-pp-kit]');
      if (kitEl && PP_KIT_STACK) {
        var kitBundle = PP_KIT_STACK;
        var kitMembers = kitBundle.slugs
          .map(function (slug) {
            for (var i = 0; i < PP_PRODUCTS.length; i++) {
              if (PP_PRODUCTS[i].slug === slug) return PP_PRODUCTS[i];
            }
            return null;
          })
          .filter(Boolean);

        if (kitMembers.length) {
          var kitExtras = parseFloat(kitEl.getAttribute('data-pp-kit-extras'));
          if (isNaN(kitExtras)) { kitExtras = 0; }
          var kitList = kitMembers.reduce(function (a, m) { return a + Number(m.price); }, 0);
          var kitCharged = kitMembers.reduce(function (a, m) {
            return a + Number(m.price);
          }, 0);

          var setKit = function (sel, text) {
            var el = kitEl.querySelector(sel);
            if (el) { el.textContent = text; }
          };
          setKit('[data-pp-kit-now]', window.zpMoney(Math.round(kitCharged * 100)));
          setKit('[data-pp-kit-was]', '$' + (kitList + kitExtras).toFixed(2));
          setKit('[data-pp-kit-perday]', '$' + (kitCharged / 30).toFixed(2) + '/day');
        }
      }

      /* --- Concern tiles / panels --- */
      var tiles = root.querySelectorAll('[data-pp-tile]');
      var panels = root.querySelectorAll('[data-pp-panel]');
      Array.prototype.forEach.call(tiles, function (tile) {
        tile.addEventListener('click', function () {
          var key = tile.getAttribute('data-pp-tile');
          Array.prototype.forEach.call(tiles, function (t) {
            t.classList.toggle('is-active', t === tile);
          });
          Array.prototype.forEach.call(panels, function (p) {
            p.classList.toggle('is-active', p.getAttribute('data-pp-panel') === key);
          });
        });
      });
    });
  })();
